// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Poppins-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Poppins-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Poppins-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Poppins-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Poppins-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Poppins-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Poppins-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Poppins-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Poppins-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Poppins-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Poppins-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/bg-ath.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/up_arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/down_arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/default.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
Template :	UserCenter - ICO Crypto
Author	 :	Softnio
Version	 :	1.0.1
Updated	 :	10.23.2022
*/
/*! Table of Contents 01.0 - Fonts 02.0 - Reset 03.0 - Utility 04.0 - Common 05.0 - Elements */
/*! 01.0 - FONTS */
@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("Poppins Bold"), local("Poppins-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: local("Poppins Light"), local("Poppins-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: local("Poppins SemiBold"), local("Poppins-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: local("Poppins Medium"), local("Poppins-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: local("Poppins Regular"), local("Poppins-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/*! 02.0 - RESET */
body {
  font-family: "Poppins", sans-serif;
  color: #3c3c3c;
  font-size: 14px;
  line-height: 1.86;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  background: #eaf3fc;
  min-width: 320px;
  color: #6783b8;
}

img {
  max-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul:not(.btn-grp),
ol,
table {
  margin-bottom: 12px;
  line-height: 1.68;
}

h1:last-child,
h2:last-child,
h3:last-child,
h4:last-child,
h5:last-child,
h6:last-child,
p:last-child,
ul:not(.btn-grp):last-child,
ol:last-child,
table:last-child {
  margin-bottom: 0;
}

h1,
.h1 {
  font-size: 1.75em;
}

h2,
.h2 {
  font-size: 1.58em;
}

h3,
.h3 {
  font-size: 1.32em;
}

h4,
.h4 {
  font-size: 1.2em;
}

h5,
.h5 {
  font-size: 1em;
}

h6,
.h6 {
  font-size: .9em;
}

p {
  font-size: 1em;
}

p.lead {
  font-size: 1.27em;
}

h1 span,
h2 span,
h3 span,
h4 span,
h5 span,
h6 span,
p span {
  color: #2b56f5;
}

ul,
ol {
  padding: 0px;
  margin: 0px;
}

ul li,
ol li {
  list-style: none;
}

.relative {
  position: relative;
}

p+h1,
p+h2,
p+h3,
p+h4,
p+h5,
p+h4,
ul+h1,
ul+h2,
ul+h3,
ul+h4,
ul+h5,
ul+h4,
ol+h1,
ol+h2,
ol+h3,
ol+h4,
ol+h5,
ol+h4,
table+h1,
table+h2,
table+h3,
table+h4,
table+h5,
table+h4 {
  margin-top: 35px;
}

ul+p,
ul+ul,
ul+ol,
ol+ol,
ol+ul,
ul+table,
ol+table {
  margin-top: 35px;
}

b,
strong {
  font-weight: 600;
}

a {
  outline: 0;
  transition: all 0.5s;
  color: #2b56f5;
}

a:link,
a:visited {
  text-decoration: none;
}

a:hover,
a:focus,
a:active {
  outline: 0;
  color: #46bdf4;
}

.container {
  z-index: 5;
}

@media (min-width: 1090px) {
  .container {
    width: 1080px;
  }
}

/*! 03.0 - UTILITY */
.ucap {
  text-transform: uppercase;
}

.cap {
  text-transform: capitalize;
}

.pad-0,
.nopd {
  padding: 0px;
}

.npl {
  padding-left: 0px;
}

.npr {
  padding-right: 0px;
}

.overflow-x-auto {
  overflow-x: auto;
}

.sap {
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background: #edf5ff;
}

.gaps-1x {
  height: 10px;
}

.gaps-2x {
  height: 20px;
}

.gaps-3x {
  height: 30px;
}

.gaps-4x {
  height: 40px;
}

.gaps-5x {
  height: 50px;
}

.gaps-6x {
  height: 60px;
}

.gaps-7x {
  height: 70px;
}

.gaps-8x {
  height: 80px;
}

.gaps-9x {
  height: 90px;
}

.gaps-10x {
  height: 100px;
}

.gaps-11x {
  height: 110px;
}

.gaps-12x {
  height: 120px;
}

.gaps-13x {
  height: 130px;
}

.gaps-14x {
  height: 140px;
}

.gaps-15x {
  height: 150px;
}

.gaps-16x {
  height: 160px;
}

.gaps-17x {
  height: 170px;
}

.gaps-18x {
  height: 180px;
}

.gaps-19x {
  height: 190px;
}

.gaps-20x {
  height: 200px;
}

.padl-1x {
  padding-left: 10px;
}

.padl-2x {
  padding-left: 20px;
}

.padl-3x {
  padding-left: 30px;
}

.padl-4x {
  padding-left: 40px;
}

.padl-5x {
  padding-left: 50px;
}

.padl-6x {
  padding-left: 60px;
}

.padl-7x {
  padding-left: 70px;
}

.padl-8x {
  padding-left: 80px;
}

.padl-9x {
  padding-left: 90px;
}

.padl-10x {
  padding-left: 100px;
}

.padl-11x {
  padding-left: 110px;
}

.padl-12x {
  padding-left: 120px;
}

.padl-13x {
  padding-left: 130px;
}

.padl-14x {
  padding-left: 140px;
}

.padl-15x {
  padding-left: 150px;
}

.padl-16x {
  padding-left: 160px;
}

.padl-17x {
  padding-left: 170px;
}

.padl-18x {
  padding-left: 180px;
}

.padl-19x {
  padding-left: 190px;
}

.padl-20x {
  padding-left: 200px;
}

.w1 {
  width: 1%;
}

.w2 {
  width: 2%;
}

.w3 {
  width: 3%;
}

.w4 {
  width: 4%;
}

.w5 {
  width: 5%;
}

.w6 {
  width: 6%;
}

.w7 {
  width: 7%;
}

.w8 {
  width: 8%;
}

.w9 {
  width: 9%;
}

.w10 {
  width: 10%;
}

.w11 {
  width: 11%;
}

.w12 {
  width: 12%;
}

.w13 {
  width: 13%;
}

.w14 {
  width: 14%;
}

.w15 {
  width: 15%;
}

.w16 {
  width: 16%;
}

.w17 {
  width: 17%;
}

.w18 {
  width: 18%;
}

.w19 {
  width: 19%;
}

.w20 {
  width: 20%;
}

.w21 {
  width: 21%;
}

.w22 {
  width: 22%;
}

.w23 {
  width: 23%;
}

.w24 {
  width: 24%;
}

.w25 {
  width: 25%;
}

.w26 {
  width: 26%;
}

.w27 {
  width: 27%;
}

.w28 {
  width: 28%;
}

.w29 {
  width: 29%;
}

.w30 {
  width: 30%;
}

.w31 {
  width: 31%;
}

.w32 {
  width: 32%;
}

.w33 {
  width: 33%;
}

.w34 {
  width: 34%;
}

.w35 {
  width: 35%;
}

.w36 {
  width: 36%;
}

.w37 {
  width: 37%;
}

.w38 {
  width: 38%;
}

.w39 {
  width: 39%;
}

.w40 {
  width: 40%;
}

.w41 {
  width: 41%;
}

.w42 {
  width: 42%;
}

.w43 {
  width: 43%;
}

.w44 {
  width: 44%;
}

.w45 {
  width: 45%;
}

.w46 {
  width: 46%;
}

.w47 {
  width: 47%;
}

.w48 {
  width: 48%;
}

.w49 {
  width: 49%;
}

.w50 {
  width: 50%;
}

.w51 {
  width: 51%;
}

.w52 {
  width: 52%;
}

.w53 {
  width: 53%;
}

.w54 {
  width: 54%;
}

.w55 {
  width: 55%;
}

.w56 {
  width: 56%;
}

.w57 {
  width: 57%;
}

.w58 {
  width: 58%;
}

.w59 {
  width: 59%;
}

.w60 {
  width: 60%;
}

.w61 {
  width: 61%;
}

.w62 {
  width: 62%;
}

.w63 {
  width: 63%;
}

.w64 {
  width: 64%;
}

.w65 {
  width: 65%;
}

.w66 {
  width: 66%;
}

.w67 {
  width: 67%;
}

.w68 {
  width: 68%;
}

.w69 {
  width: 69%;
}

.w70 {
  width: 70%;
}

.w71 {
  width: 71%;
}

.w72 {
  width: 72%;
}

.w73 {
  width: 73%;
}

.w74 {
  width: 74%;
}

.w75 {
  width: 75%;
}

.w76 {
  width: 76%;
}

.w77 {
  width: 77%;
}

.w78 {
  width: 78%;
}

.w79 {
  width: 79%;
}

.w80 {
  width: 80%;
}

.w81 {
  width: 81%;
}

.w82 {
  width: 82%;
}

.w83 {
  width: 83%;
}

.w84 {
  width: 84%;
}

.w85 {
  width: 85%;
}

.w86 {
  width: 86%;
}

.w87 {
  width: 87%;
}

.w88 {
  width: 88%;
}

.w89 {
  width: 89%;
}

.w90 {
  width: 90%;
}

.w91 {
  width: 91%;
}

.w92 {
  width: 92%;
}

.w93 {
  width: 93%;
}

.w94 {
  width: 94%;
}

.w95 {
  width: 95%;
}

.w96 {
  width: 96%;
}

.w97 {
  width: 97%;
}

.w98 {
  width: 98%;
}

.w99 {
  width: 99%;
}

.w100 {
  width: 100%;
}

.w1px {
  width: 1px;
}

.w2px {
  width: 2px;
}

.w3px {
  width: 3px;
}

.w4px {
  width: 4px;
}

.w5px {
  width: 5px;
}

.w6px {
  width: 6px;
}

.w7px {
  width: 7px;
}

.w8px {
  width: 8px;
}

.w9px {
  width: 9px;
}

.w10px {
  width: 10px;
}

.w11px {
  width: 11px;
}

.w12px {
  width: 12px;
}

.w13px {
  width: 13px;
}

.w14px {
  width: 14px;
}

.w15px {
  width: 15px;
}

.w16px {
  width: 16px;
}

.w17px {
  width: 17px;
}

.w18px {
  width: 18px;
}

.w19px {
  width: 19px;
}

.w20px {
  width: 20px;
}

.w21px {
  width: 21px;
}

.w22px {
  width: 22px;
}

.w23px {
  width: 23px;
}

.w24px {
  width: 24px;
}

.w25px {
  width: 25px;
}

.w26px {
  width: 26px;
}

.w27px {
  width: 27px;
}

.w28px {
  width: 28px;
}

.w29px {
  width: 29px;
}

.w30px {
  width: 30px;
}

.w31px {
  width: 31px;
}

.w32px {
  width: 32px;
}

.w33px {
  width: 33px;
}

.w34px {
  width: 34px;
}

.w35px {
  width: 35px;
}

.w36px {
  width: 36px;
}

.w37px {
  width: 37px;
}

.w38px {
  width: 38px;
}

.w39px {
  width: 39px;
}

.w40px {
  width: 40px;
}

.w41px {
  width: 41px;
}

.w42px {
  width: 42px;
}

.w43px {
  width: 43px;
}

.w44px {
  width: 44px;
}

.w45px {
  width: 45px;
}

.w46px {
  width: 46px;
}

.w47px {
  width: 47px;
}

.w48px {
  width: 48px;
}

.w49px {
  width: 49px;
}

.w50px {
  width: 50px;
}

.w51px {
  width: 51px;
}

.w52px {
  width: 52px;
}

.w53px {
  width: 53px;
}

.w54px {
  width: 54px;
}

.w55px {
  width: 55px;
}

.w56px {
  width: 56px;
}

.w57px {
  width: 57px;
}

.w58px {
  width: 58px;
}

.w59px {
  width: 59px;
}

.w60px {
  width: 60px;
}

.w61px {
  width: 61px;
}

.w62px {
  width: 62px;
}

.w63px {
  width: 63px;
}

.w64px {
  width: 64px;
}

.w65px {
  width: 65px;
}

.w66px {
  width: 66px;
}

.w67px {
  width: 67px;
}

.w68px {
  width: 68px;
}

.w69px {
  width: 69px;
}

.w70px {
  width: 70px;
}

.w71px {
  width: 71px;
}

.w72px {
  width: 72px;
}

.w73px {
  width: 73px;
}

.w74px {
  width: 74px;
}

.w75px {
  width: 75px;
}

.w76px {
  width: 76px;
}

.w77px {
  width: 77px;
}

.w78px {
  width: 78px;
}

.w79px {
  width: 79px;
}

.w80px {
  width: 80px;
}

.w81px {
  width: 81px;
}

.w82px {
  width: 82px;
}

.w83px {
  width: 83px;
}

.w84px {
  width: 84px;
}

.w85px {
  width: 85px;
}

.w86px {
  width: 86px;
}

.w87px {
  width: 87px;
}

.w88px {
  width: 88px;
}

.w89px {
  width: 89px;
}

.w90px {
  width: 90px;
}

.w91px {
  width: 91px;
}

.w92px {
  width: 92px;
}

.w93px {
  width: 93px;
}

.w94px {
  width: 94px;
}

.w95px {
  width: 95px;
}

.w96px {
  width: 96px;
}

.w97px {
  width: 97px;
}

.w98px {
  width: 98px;
}

.w99px {
  width: 99px;
}

.w100px {
  width: 100px;
}

.wauto {
  width: auto;
}

.hauto {
  height: auto;
}

.vh100 {
  height: 100vh;
}

.guttar-1px {
  margin-left: -0.5px;
  margin-right: -0.5px;
}

.guttar-1px>li,
.guttar-1px>div {
  padding-left: 0.5px;
  padding-right: 0.5px;
}

.guttar-2px {
  margin-left: -1px;
  margin-right: -1px;
}

.guttar-2px>li,
.guttar-2px>div {
  padding-left: 1px;
  padding-right: 1px;
}

.guttar-3px {
  margin-left: -1.5px;
  margin-right: -1.5px;
}

.guttar-3px>li,
.guttar-3px>div {
  padding-left: 1.5px;
  padding-right: 1.5px;
}

.guttar-4px {
  margin-left: -2px;
  margin-right: -2px;
}

.guttar-4px>li,
.guttar-4px>div {
  padding-left: 2px;
  padding-right: 2px;
}

.guttar-5px {
  margin-left: -2.5px;
  margin-right: -2.5px;
}

.guttar-5px>li,
.guttar-5px>div {
  padding-left: 2.5px;
  padding-right: 2.5px;
}

.guttar-6px {
  margin-left: -3px;
  margin-right: -3px;
}

.guttar-6px>li,
.guttar-6px>div {
  padding-left: 3px;
  padding-right: 3px;
}

.guttar-7px {
  margin-left: -3.5px;
  margin-right: -3.5px;
}

.guttar-7px>li,
.guttar-7px>div {
  padding-left: 3.5px;
  padding-right: 3.5px;
}

.guttar-8px {
  margin-left: -4px;
  margin-right: -4px;
}

.guttar-8px>li,
.guttar-8px>div {
  padding-left: 4px;
  padding-right: 4px;
}

.guttar-9px {
  margin-left: -4.5px;
  margin-right: -4.5px;
}

.guttar-9px>li,
.guttar-9px>div {
  padding-left: 4.5px;
  padding-right: 4.5px;
}

.guttar-10px {
  margin-left: -5px;
  margin-right: -5px;
}

.guttar-10px>li,
.guttar-10px>div {
  padding-left: 5px;
  padding-right: 5px;
}

.guttar-11px {
  margin-left: -5.5px;
  margin-right: -5.5px;
}

.guttar-11px>li,
.guttar-11px>div {
  padding-left: 5.5px;
  padding-right: 5.5px;
}

.guttar-12px {
  margin-left: -6px;
  margin-right: -6px;
}

.guttar-12px>li,
.guttar-12px>div {
  padding-left: 6px;
  padding-right: 6px;
}

.guttar-13px {
  margin-left: -6.5px;
  margin-right: -6.5px;
}

.guttar-13px>li,
.guttar-13px>div {
  padding-left: 6.5px;
  padding-right: 6.5px;
}

.guttar-14px {
  margin-left: -7px;
  margin-right: -7px;
}

.guttar-14px>li,
.guttar-14px>div {
  padding-left: 7px;
  padding-right: 7px;
}

.guttar-15px {
  margin-left: -7.5px;
  margin-right: -7.5px;
}

.guttar-15px>li,
.guttar-15px>div {
  padding-left: 7.5px;
  padding-right: 7.5px;
}

.guttar-16px {
  margin-left: -8px;
  margin-right: -8px;
}

.guttar-16px>li,
.guttar-16px>div {
  padding-left: 8px;
  padding-right: 8px;
}

.guttar-17px {
  margin-left: -8.5px;
  margin-right: -8.5px;
}

.guttar-17px>li,
.guttar-17px>div {
  padding-left: 8.5px;
  padding-right: 8.5px;
}

.guttar-18px {
  margin-left: -9px;
  margin-right: -9px;
}

.guttar-18px>li,
.guttar-18px>div {
  padding-left: 9px;
  padding-right: 9px;
}

.guttar-19px {
  margin-left: -9.5px;
  margin-right: -9.5px;
}

.guttar-19px>li,
.guttar-19px>div {
  padding-left: 9.5px;
  padding-right: 9.5px;
}

.guttar-20px {
  margin-left: -10px;
  margin-right: -10px;
}

.guttar-20px>li,
.guttar-20px>div {
  padding-left: 10px;
  padding-right: 10px;
}

.guttar-21px {
  margin-left: -10.5px;
  margin-right: -10.5px;
}

.guttar-21px>li,
.guttar-21px>div {
  padding-left: 10.5px;
  padding-right: 10.5px;
}

.guttar-22px {
  margin-left: -11px;
  margin-right: -11px;
}

.guttar-22px>li,
.guttar-22px>div {
  padding-left: 11px;
  padding-right: 11px;
}

.guttar-23px {
  margin-left: -11.5px;
  margin-right: -11.5px;
}

.guttar-23px>li,
.guttar-23px>div {
  padding-left: 11.5px;
  padding-right: 11.5px;
}

.guttar-24px {
  margin-left: -12px;
  margin-right: -12px;
}

.guttar-24px>li,
.guttar-24px>div {
  padding-left: 12px;
  padding-right: 12px;
}

.guttar-25px {
  margin-left: -12.5px;
  margin-right: -12.5px;
}

.guttar-25px>li,
.guttar-25px>div {
  padding-left: 12.5px;
  padding-right: 12.5px;
}

.guttar-26px {
  margin-left: -13px;
  margin-right: -13px;
}

.guttar-26px>li,
.guttar-26px>div {
  padding-left: 13px;
  padding-right: 13px;
}

.guttar-27px {
  margin-left: -13.5px;
  margin-right: -13.5px;
}

.guttar-27px>li,
.guttar-27px>div {
  padding-left: 13.5px;
  padding-right: 13.5px;
}

.guttar-28px {
  margin-left: -14px;
  margin-right: -14px;
}

.guttar-28px>li,
.guttar-28px>div {
  padding-left: 14px;
  padding-right: 14px;
}

.guttar-29px {
  margin-left: -14.5px;
  margin-right: -14.5px;
}

.guttar-29px>li,
.guttar-29px>div {
  padding-left: 14.5px;
  padding-right: 14.5px;
}

.guttar-30px {
  margin-left: -15px;
  margin-right: -15px;
}

.guttar-30px>li,
.guttar-30px>div {
  padding-left: 15px;
  padding-right: 15px;
}

.guttar-31px {
  margin-left: -15.5px;
  margin-right: -15.5px;
}

.guttar-31px>li,
.guttar-31px>div {
  padding-left: 15.5px;
  padding-right: 15.5px;
}

.guttar-32px {
  margin-left: -16px;
  margin-right: -16px;
}

.guttar-32px>li,
.guttar-32px>div {
  padding-left: 16px;
  padding-right: 16px;
}

.guttar-33px {
  margin-left: -16.5px;
  margin-right: -16.5px;
}

.guttar-33px>li,
.guttar-33px>div {
  padding-left: 16.5px;
  padding-right: 16.5px;
}

.guttar-34px {
  margin-left: -17px;
  margin-right: -17px;
}

.guttar-34px>li,
.guttar-34px>div {
  padding-left: 17px;
  padding-right: 17px;
}

.guttar-35px {
  margin-left: -17.5px;
  margin-right: -17.5px;
}

.guttar-35px>li,
.guttar-35px>div {
  padding-left: 17.5px;
  padding-right: 17.5px;
}

.guttar-36px {
  margin-left: -18px;
  margin-right: -18px;
}

.guttar-36px>li,
.guttar-36px>div {
  padding-left: 18px;
  padding-right: 18px;
}

.guttar-37px {
  margin-left: -18.5px;
  margin-right: -18.5px;
}

.guttar-37px>li,
.guttar-37px>div {
  padding-left: 18.5px;
  padding-right: 18.5px;
}

.guttar-38px {
  margin-left: -19px;
  margin-right: -19px;
}

.guttar-38px>li,
.guttar-38px>div {
  padding-left: 19px;
  padding-right: 19px;
}

.guttar-39px {
  margin-left: -19.5px;
  margin-right: -19.5px;
}

.guttar-39px>li,
.guttar-39px>div {
  padding-left: 19.5px;
  padding-right: 19.5px;
}

.guttar-40px {
  margin-left: -20px;
  margin-right: -20px;
}

.guttar-40px>li,
.guttar-40px>div {
  padding-left: 20px;
  padding-right: 20px;
}

.guttar-41px {
  margin-left: -20.5px;
  margin-right: -20.5px;
}

.guttar-41px>li,
.guttar-41px>div {
  padding-left: 20.5px;
  padding-right: 20.5px;
}

.guttar-42px {
  margin-left: -21px;
  margin-right: -21px;
}

.guttar-42px>li,
.guttar-42px>div {
  padding-left: 21px;
  padding-right: 21px;
}

.guttar-43px {
  margin-left: -21.5px;
  margin-right: -21.5px;
}

.guttar-43px>li,
.guttar-43px>div {
  padding-left: 21.5px;
  padding-right: 21.5px;
}

.guttar-44px {
  margin-left: -22px;
  margin-right: -22px;
}

.guttar-44px>li,
.guttar-44px>div {
  padding-left: 22px;
  padding-right: 22px;
}

.guttar-45px {
  margin-left: -22.5px;
  margin-right: -22.5px;
}

.guttar-45px>li,
.guttar-45px>div {
  padding-left: 22.5px;
  padding-right: 22.5px;
}

.guttar-46px {
  margin-left: -23px;
  margin-right: -23px;
}

.guttar-46px>li,
.guttar-46px>div {
  padding-left: 23px;
  padding-right: 23px;
}

.guttar-47px {
  margin-left: -23.5px;
  margin-right: -23.5px;
}

.guttar-47px>li,
.guttar-47px>div {
  padding-left: 23.5px;
  padding-right: 23.5px;
}

.guttar-48px {
  margin-left: -24px;
  margin-right: -24px;
}

.guttar-48px>li,
.guttar-48px>div {
  padding-left: 24px;
  padding-right: 24px;
}

.guttar-49px {
  margin-left: -24.5px;
  margin-right: -24.5px;
}

.guttar-49px>li,
.guttar-49px>div {
  padding-left: 24.5px;
  padding-right: 24.5px;
}

.guttar-50px {
  margin-left: -25px;
  margin-right: -25px;
}

.guttar-50px>li,
.guttar-50px>div {
  padding-left: 25px;
  padding-right: 25px;
}

/** Button **/
.btn {
  position: relative;
  color: #fff;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
  border-radius: 4px;
  transition: all .4s ease;
}

.btn:hover,
.btn:focus,
.btn:active {
  box-shadow: none;
  outline: none;
}

.btn .ti,
.btn [class*=fa-] {
  margin-right: 8px;
}

.btn-icon {
  letter-spacing: 0.01em;
}

.btn-sm {
  padding: 10px 18px;
  line-height: 19px;
}

.btn-xs {
  padding: 5px 12px;
  font-size: 11px;
  line-height: 18px;
  text-transform: none;
  letter-spacing: 0.025em;
}

.btn-uline {
  padding: 0;
}

.btn-uline:after {
  position: absolute;
  content: '';
  height: 1px;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all .4s;
}

.btn-uline-light {
  color: #91a5cb;
}

.btn-uline-light:after {
  background: #91a5cb;
}

.btn-uline-light:hover,
.btn-uline-light:focus,
.btn-uline-light:active {
  color: #6783b8;
}

.btn-uline-light:hover:after,
.btn-uline-light:focus:after,
.btn-uline-light:active:after {
  background: #6783b8;
}

.btn-uline-warning {
  color: #ffdc70;
}

.btn-uline-warning:after {
  background: #ffdc70;
}

.btn-uline-warning:hover,
.btn-uline-warning:focus,
.btn-uline-warning:active {
  color: #ffc100;
}

.btn-uline-warning:hover:after,
.btn-uline-warning:focus:after,
.btn-uline-warning:active:after {
  background: #ffc100;
}

.btn-uline-primary {
  color: #96abfa;
}

.btn-uline-primary:after {
  background: #96abfa;
}

.btn-uline-primary:hover,
.btn-uline-primary:focus,
.btn-uline-primary:active {
  color: #2b56f5;
}

.btn-uline-primary:hover:after,
.btn-uline-primary:focus:after,
.btn-uline-primary:active:after {
  background: #2b56f5;
}

.btn-uline-info {
  color: #f7fbff;
}

.btn-uline-info:after {
  background: #f7fbff;
}

.btn-uline-info:hover,
.btn-uline-info:focus,
.btn-uline-info:active {
  color: #87bfff;
}

.btn-uline-info:hover:after,
.btn-uline-info:focus:after,
.btn-uline-info:active:after {
  background: #87bfff;
}

.btn-uline-success {
  color: #43ffba;
}

.btn-uline-success:after {
  background: #43ffba;
}

.btn-uline-success:hover,
.btn-uline-success:focus,
.btn-uline-success:active {
  color: #00d285;
}

.btn-uline-success:hover:after,
.btn-uline-success:focus:after,
.btn-uline-success:active:after {
  background: #00d285;
}

.btn-uline-danger {
  color: #ff7070;
}

.btn-uline-danger:after {
  background: #ff7070;
}

.btn-uline-danger:hover,
.btn-uline-danger:focus,
.btn-uline-danger:active {
  color: #ff0000;
}

.btn-uline-danger:hover:after,
.btn-uline-danger:focus:after,
.btn-uline-danger:active:after {
  background: #ff0000;
}

.btn-facebook {
  background: #3b5998;
  border-color: #3b5998;
  box-shadow: 0px 2px 18px 2px rgba(59, 89, 152, 0.25);
}

.btn-facebook:hover,
.btn-facebook:focus,
.btn-facebook:active {
  color: #fff;
  background: #344e86;
  border-color: #344e86;
}

.btn-google {
  background: #d85040;
  border-color: #d85040;
  box-shadow: 0px 2px 18px 2px rgba(216, 80, 64, 0.25);
}

.btn-google:hover,
.btn-google:focus,
.btn-google:active {
  color: #fff;
  background: #d33d2b;
  border-color: #d33d2b;
}

.btn-light {
  background: #6783b8;
  border-color: #6783b8;
  box-shadow: 0px 2px 18px 2px rgba(103, 131, 184, 0.25);
}

.btn-light:hover,
.btn-light:focus,
.btn-light:active {
  color: #fff;
  background: #5675b0;
  border-color: #5675b0;
}

.btn-warning {
  background: #ffc100;
  border-color: #ffc100;
  box-shadow: 0px 2px 18px 2px rgba(255, 193, 0, 0.25);
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active {
  color: #fff;
  background: #e6ae00;
  border-color: #e6ae00;
}

.btn-primary {
  background: #2b56f5;
  border-color: #2b56f5;
  box-shadow: 0px 2px 18px 2px rgba(43, 86, 245, 0.25);
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  color: #fff;
  background: #1343f4;
  border-color: #1343f4;
}

.btn-info {
  background: #87bfff;
  border-color: #87bfff;
  box-shadow: 0px 2px 18px 2px rgba(135, 191, 255, 0.25);
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active {
  color: #fff;
  background: #6eb1ff;
  border-color: #6eb1ff;
}

.btn-success {
  background: #00d285;
  border-color: #00d285;
  box-shadow: 0px 2px 18px 2px rgba(0, 210, 133, 0.25);
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active {
  color: #fff;
  background: #00b975;
  border-color: #00b975;
}

.btn-danger {
  background: #ff0000;
  border-color: #ff0000;
  box-shadow: 0px 2px 18px 2px rgba(255, 0, 0, 0.25);
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active {
  color: #fff;
  background: #e60000;
  border-color: #e60000;
}

.btn-grp {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: -10px;
  margin-bottom: -10px;
}

.btn-grp li {
  padding-top: 10px;
  padding-bottom: 10px;
}

.btn-grp .btn-uline {
  position: relative;
  top: -4px;
}

.note {
  padding: 15px 15px 15px 45px;
  border-radius: 4px;
  position: relative;
}

.note-no-icon {
  padding: 15px;
}

.note-no-icon.note-lg {
  padding: 15px 25px;
}

.note [class*=fa] {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-size: 12px;
  line-height: 20px;
  width: 45px;
  text-align: center;
}

.note p {
  font-size: 12px !important;
  line-height: 1.5em;
}

.note-md p {
  font-size: 13px !important;
}

.note-plane {
  padding: 0 0 0 20px;
  background: transparent !important;
}

.note-plane [class*=fa] {
  top: 0;
  transform: translateY(0);
  left: 0;
  font-size: 12px;
  line-height: 18px;
  width: 20px;
  text-align: left;
}

.note-info {
  background: #edf5ff;
}

.note-info p {
  color: #6783b8 !important;
}

.note-info [class*=fa] {
  color: #87bfff;
}

.note-success {
  background: rgba(0, 210, 133, 0.15);
}

.note-success p {
  color: rgba(0, 210, 133, 0.9) !important;
}

.note-success [class*=fa] {
  color: #00d285;
}

.note-danger {
  background: rgba(255, 0, 0, 0.05);
}

.note-danger p {
  color: rgba(255, 0, 0, 0.7) !important;
}

.note-danger [class*=fa] {
  color: rgba(255, 0, 0, 0.7);
}

.alert-xs {
  padding: 5px 12px;
  font-size: 11px;
  line-height: 18px;
  text-transform: none;
  letter-spacing: 0.025em;
}

.alert-success {
  color: #fff;
  background: #00d285;
  border-color: #00d285;
  box-shadow: 0px 2px 18px 2px rgba(0, 210, 133, 0.25);
}

.alert-error {
  color: #fff;
  background: #ff0000;
  border-color: #ff0000;
  box-shadow: 0px 2px 18px 2px rgba(255, 0, 0, 0.25);
}

.alert-box {
  text-align: center;
  border-radius: 4px;
  padding: 15px;
  display: block;
  border: 1px solid;
  margin-bottom: 30px;
}

.alert-primary {
  background: #def8ff;
  border-color: #bae2ed;
}

.alert-txt {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  font-size: 12px;
}

.alert-txt .ti,
.alert-txt .iconfont,
.alert-txt [class*=fa-] {
  margin-right: 10px;
  line-height: 36px;
  width: 36px;
  border-radius: 50%;
  text-align: center;
  background: #f2b2a7;
  color: #af4038;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .alert-box {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .alert-txt {
    padding-bottom: 0;
    font-size: 14px;
    justify-content: flex-start;
  }
}

.color-light {
  color: #6783b8;
}

.color-dark {
  color: #304073;
}

.color-warning {
  color: #ffc100;
}

.color-primary {
  color: #2b56f5;
}

.color-info {
  color: #87bfff;
}

.color-success {
  color: #00d285;
}

.color-danger {
  color: #ff0000;
}

/** Table **/
.table tr {
  background: rgba(220, 230, 245, 0.2);
}

.table tr:nth-child(even) {
  background: rgba(220, 230, 245, 0.6);
}

.table tr:last-child td:first-child {
  border-radius: 0 0 0 4px;
}

.table tr:last-child td:last-child {
  border-radius: 0 0 4px 0;
}

.table td {
  padding: 10px 20px;
  border: none;
  white-space: nowrap;
  color: #304073;
}

.table td span {
  color: #6783b8;
  display: block;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.1;
  padding-top: 5px;
}

.table thead tr {
  background: #d4e0f3;
}

.table thead th {
  padding: 10px 20px;
  border: none;
  color: #6783b8;
  white-space: nowrap;
}

.table thead th:first-child {
  border-radius: 4px 0 0 0;
}

.table thead th:last-child {
  border-radius: 0 4px 0 0;
}

/** Accordion @simple **/
.accordion-simple {
  padding-bottom: 25px;
}

.accordion-simple:last-child {
  padding-bottom: 0;
}

.accordion-item {
  padding-bottom: 5px;
  border: none;
}

.accordion-item:last-child {
  padding-bottom: 0;
}

.accordion-heading {
  cursor: pointer;
  color: #6783b8;
  font-weight: 500;
  transition: all .4s;
  margin-bottom: 8px;
  padding-left: 20px;
  font-size: 1em;
  position: relative;
}

.accordion-heading:before,
.accordion-heading:after {
  position: absolute;
  content: '';
}

.accordion-heading:before {
  left: 0;
  top: 10px;
  height: 1px;
  width: 11px;
  background: #6783b8;
}

.accordion-heading:after {
  left: 5px;
  top: 5px;
  height: 11px;
  width: 1px;
  background: #6783b8;
  transform: scaleX(1) scaleY(0);
  transition: all .3s ease;
}

.accordion-heading.collapsed:after {
  transform: scaleX(1) scaleY(1);
}

.accordion-heading:hover {
  color: #304073;
}

.accordion-content {
  padding: 0 0 15px 20px;
}

.or-saparator {
  position: relative;
  padding: 10px 0;
}

.or-saparator:before {
  position: absolute;
  top: 50%;
  left: 0;
  height: 1px;
  margin-top: 1px;
  width: 100%;
  content: '';
  background: rgba(40, 56, 76, 0.1);
  z-index: 1;
}

.or-saparator span {
  position: relative;
  display: inline-block;
  font-size: 0.81em;
  padding: 0 8px;
  background: #fff;
  color: #6783b8;
  z-index: 2;
}

.small-heading {
  display: block;
  font-size: .8em;
  line-height: 1;
  letter-spacing: 0.2em;
  color: #304073;
  margin-bottom: 20px;
}

.simple-link {
  font-size: 13px;
}

.simple-link .ti {
  font-size: 10px;
  font-weight: bold;
}

/** Dropdown **/
.dropdown-menu {
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

/** Tooltip **/
[data-toggle="tooltip"] {
  cursor: help;
}

.tooltip-inner {
  background: #fff;
  font-size: 10px;
  color: #6783b8;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.07);
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #fff !important;
}

.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #fff !important;
}

.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #fff !important;
}

.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #fff !important;
}

.modal-content {
  position: relative;
  border-radius: 8px;
  border: 2px solid #d3e0f3;
  box-shadow: 0px 0px 50px 0px rgba(48, 64, 115, 0.1);
}

.modal-content .modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-block;
}

.modal-content .modal-close .fa,
.modal-content .modal-close .ti {
  font-size: 20px;
  height: 44px;
  width: 44px;
  line-height: 44px;
  text-align: center;
  background: #c1d1e8;
  border-radius: 50%;
  color: #304073;
  text-shadow: none;
  display: block;
  transition: all .4s;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 100%;
    min-width: 100%;
  }
}

@media (min-width: 640px) {
  .modal-dialog {
    max-width: 630px;
    min-width: 630px;
  }
}

@media (min-width: 660px) {
  .modal-content .modal-close {
    top: -22px;
    right: -22px;
  }
}

/** Select **/
select:focus {
  outline: none;
  border: none;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 40px;
  font-size: .9em;
  padding-left: 15px;
  padding-right: 44px;
  color: #304073;
}

.select2-container[dir="rtl"] .select2-selection--single .select2-selection__rendered {
  padding-right: 20px;
  padding-left: 44px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #e3f0ff;
  color: #304073;
}

.select2-container--default .select2-results__option[aria-selected=true] {
  background: #e3f0ff;
  color: #304073;
}

.select2-container--default .select2-results__option {
  padding: 12px 20px;
  border-bottom: 1px solid #edf5ff;
}

.select2-container--default .select2-results__option:last-child {
  border-bottom: none;
}

.select2-container .select2-selection--single {
  height: 44px;
}

.select2-container--default .select2-selection--single {
  background: #fff;
  color: #8599c6;
  border: 2px solid #d3e0f3;
  border-radius: 4px;
  transition: all .4s;
}

.select2-container--default .select2-selection--single:focus {
  outline: none;
}

.select2-container--open.select2-container--default .select2-selection--single {
  border: 2px solid #a1cdff;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 44px;
  width: 44px;
  top: 0;
  right: 0;
  transition: all .5s ease;
}

.select2-container--default .select2-selection--single .select2-selection__arrow:after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 0;
  width: 0;
  content: '';
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #8599c7;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  display: none;
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow {
  transform: rotate(-180deg);
}

.select2-container.select2-container--open {
  width: auto !important;
  max-width: 100% !important;
}

.select2-container.select2 {
  width: 100% !important;
}

.auto-width .select2-container.select2 {
  width: auto !important;
}

.select2-container--default .select2-results>.select2-results__options {
  max-height: 400px;
  overflow: scroll;
  background: #fff;
  border: 2px solid #a1cdff;
}

.select2-container--default .select2-dropdown--below .select2-results>.select2-results__options {
  border-radius: 0 0 4px 4px;
  border-top: none;
}

.select2-container--default .select2-dropdown--above .select2-results>.select2-results__options {
  border-radius: 4px 4px 0 0;
  border-bottom: none;
}

.select2-search--dropdown {
  display: none;
}

.select2-dropdown {
  border-radius: 0;
  border: none;
  background: transparent;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.03);
}

.select2-results__option {
  padding: 6px 20px;
  transition: all .5s ease;
}

/** Topbar **/
.topbar {
  background: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  min-width: 310px;
  box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.02);
}

.topbar-md {
  position: relative;
  background: #fff;
  z-index: 2;
  text-align: center;
}

.topbar-action {
  border-top: 1px solid rgba(234, 243, 252, 0.5);
  box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.02);
  transition: all .4s ease;
}

.topbar-action.active {
  opacity: 1;
  top: 64px;
  visibility: visible;
}

.topbar-action-list {
  display: inline-flex;
  align-items: center;
  margin: 0 -15px;
  justify-content: center;
}

.topbar-action-list .topbar-action-item {
  padding: 0 15px;
}

.topbar-action-item {
  flex-shrink: 0;
}

.topbar-action-item>a {
  padding: 15px 0;
  display: inline-block;
  color: #5e698c;
}

.topbar-action-item>a:hover {
  color: #2b56f5;
}

.topbar-action-item .dropdown-menu {
  min-width: auto;
  margin: 0;
  padding: 0;
}

.topbar-action-item .user-box {
  padding: 10px 20px;
}

.topbar-action-link a {
  font-size: 14px;
  line-height: 30px;
}

.topbar-action-link .ti,
.topbar-action-link .icofont,
.topbar-action-link [class*="fa-"] {
  font-size: 18px;
  margin-right: 10px;
  line-height: 30px;
}

.topbar-action-language a {
  color: #323d63;
  font-weight: 500;
}

.topbar-action-language a:hover {
  color: #2b56f5;
}

.topbar-action-language.show>a {
  color: #2b56f5;
}

.topbar-action-language .ti,
.topbar-action-language .icofont,
.topbar-action-language [class*="fa-"] {
  font-size: 12px;
  margin-left: 5px;
  line-height: 30px;
  font-weight: 400;
}

.topbar-action-language .dropdown-menu li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.02);
}

.topbar-action-language .dropdown-menu li:last-child {
  border-bottom: none;
}

.topbar-action-language .dropdown-menu li a {
  display: block;
  line-height: 18px;
  padding: 7px 25px;
  font-size: 14px;
  letter-spacing: 0.1em;
}

.topbar-action-language.dropdown .dropdown-menu {
  top: 100% !important;
  left: 50% !important;
  transform: translate(-50%, 0) !important;
  margin-top: 11px;
}

.topbar-action-language.dropdown .dropdown-menu:before {
  position: absolute;
  top: -7px;
  left: 50%;
  margin-left: -7px;
  height: 0;
  width: 0;
  content: '';
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
}

.topbar-action-language.dropup .dropdown-menu {
  margin-bottom: -10px;
}

.topbar-action-user .dropdown-menu {
  margin-top: 11px;
  margin-right: -5px;
}

.topbar-action-user>a img {
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.topbar-action-user .user-box {
  text-align: right;
}

.toggle-nav,
.toggle-action {
  width: 30px;
  display: block;
  transition: all .4s;
}

.toggle-nav {
  left: 10px;
}

.toggle-nav .toggle-icon {
  margin: -7.5px 0;
}

.toggle-nav.active .toggle-line {
  width: 30px;
}

.toggle-nav.active .toggle-line:nth-last-of-type(1) {
  transform-origin: bottom left;
  transform: rotate(-45deg);
}

.toggle-nav.active .toggle-line:nth-last-of-type(2) {
  opacity: 0;
}

.toggle-nav.active .toggle-line:nth-last-of-type(3) {
  opacity: 0;
}

.toggle-nav.active .toggle-line:nth-last-of-type(4) {
  transform-origin: top left;
  transform: rotate(45deg);
}

.toggle-action {
  right: 10px;
}

.toggle-action .toggle-icon {
  margin: -4px 0;
}

.toggle-action.active .toggle-dot {
  position: relative;
}

.toggle-action.active .toggle-dot:nth-last-of-type(1) {
  transform: translate(-9px, -8px);
}

.toggle-action.active .toggle-dot:nth-last-of-type(3) {
  transform: translate(9px, 8px);
}

.toggle-line {
  display: block;
  width: 28px;
  height: 2px;
  line-height: 0;
  background: #6783b8;
  margin: 5px 0;
  transition: all .4s;
}

.toggle-line:nth-last-of-type(2) {
  width: 70%;
}

.toggle-line:nth-last-of-type(3) {
  width: 85%;
}

.toggle-dot {
  display: block;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  border: 1px solid #6783b8;
  margin: 2px auto;
  transition: all .4s;
}

.site-brand {
  display: inline-block;
}

/** User **/
.user-sidebar {
  position: fixed;
  width: 260px;
  z-index: 99;
  top: 0;
  left: -260px;
  height: 100%;
  overflow: scroll;
  padding: 60px 20px 20px 20px;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
  transition: all .4s ease;
  display: none;
}

.user-sidebar:before {
  position: fixed;
  top: 0;
  left: -260px;
  content: '';
  height: 100%;
  width: 260px;
  background: #fff;
  z-index: 1;
  transition: all .4s ease;
}

.user-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  content: '';
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  transition: all .4s;
  visibility: hidden;
  opacity: 0;
  z-index: -1;
}

.user-sidebar.active {
  left: 0;
}

.user-sidebar.active:before {
  left: 0;
}

.user-sidebar.active .user-sidebar-overlay {
  opacity: 1;
  visibility: visible;
  transition-delay: 0.6s;
}

.user-sidebar-mobile {
  display: block;
}

.user-sidebar>*:not(.user-sidebar-overlay) {
  position: relative;
  z-index: 2;
}

.user-sidebar-sap {
  width: 30px;
  height: 3px;
  background: #d3e0f3;
}

.user-sidebar .topbar-action-link a {
  font-size: 12px;
}

.user-sidebar-shown {
  overflow: hidden;
}

.user-content {
  flex-grow: 1;
  max-width: 100%;
}

.user-panel {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  min-height: 100%;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
}

.user-panel-title {
  color: #304073;
}

.user-panel-subtitle {
  color: #6783b8;
  font-weight: 400;
  margin-bottom: 8px;
}

.user-panel-subtitle-red {
  color: #fa5205;
  font-weight: 400;
  margin-bottom: 8px;
}

.user-panel p {
  font-size: 14px;
  color: #304073;
}

.user-panel-content img {
  margin-bottom: 30px;
}

.user-panel-content .embed-responsive {
  margin-bottom: 30px;
}

.user-kyc {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
}

.user-kyc p {
  font-size: 14px;
  color: #304073;
}

.user-dashboard {
  padding-top: 80px;
}

.user-box {
  text-align: center;
}

.user-dropdown {
  min-width: 260px;
  box-shadow: 0px 6px 22px 0px rgba(0, 0, 0, 0.05);
}

.user-dropdown-head {
  background: #2b56f5;
  padding: 20px 20px 12px 20px;
  border-radius: 4px 4px 0 0;
  position: relative;
}

.user-dropdown-head:after {
  position: absolute;
  right: 12px;
  top: -7px;
  height: 0;
  width: 0;
  content: '';
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #2b56f5;
}

.user-dropdown-name {
  color: #fff;
  margin-bottom: 0;
  line-height: 1;
}

.user-dropdown-name span {
  font-size: 11px;
  color: #87bfff;
  line-height: 1;
}

.user-dropdown-email {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

.user-dropdown-balance {
  padding: 14px 20px 17px 20px;
}

.user-dropdown-balance h6 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 0;
  letter-spacing: 0.1em;
  color: #6783b8;
}

.user-dropdown-balance h3 {
  font-weight: 400;
  margin-bottom: 0;
  letter-spacing: -0.025em;
  color: #304073;
  line-height: 1;
  margin-top: 3px;
}

.user-dropdown-balance ul {
  margin: 0 -8px;
}

.user-dropdown-balance ul li {
  color: #9eaecf;
  display: inline-block;
  padding: 0 8px;
  font-size: 11px;
  line-height: 18px;
}

.user-dropdown-btns {
  padding: 5px 0;
  border-top: 2px solid rgba(239, 246, 255, 0.5);
  width: 100%;
  justify-content: center;
}

.user-dropdown-links {
  border-top: 2px solid rgba(239, 246, 255, 0.5);
  margin-top: 0;
  padding: 5px 0;
}

.user-dropdown-links li a {
  color: #6783b8;
  font-size: 15px;
  padding: 4px 20px;
  display: block;
}

.user-dropdown-links li a:hover {
  color: #2b56f5;
}

.user-dropdown-links li a .ti {
  width: 30px;
  display: inline-block;
}

.user-dropdown-links li.active a {
  color: #2b56f5;
}

.user-image img {
  width: 70px;
}

.user-name {
  color: #304073;
  margin-top: 8px;
  margin-bottom: 8px;
  white-space: nowrap;
}

.user-uid {
  padding-bottom: 10px;
  color: #6783b8;
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  padding-bottom: 10px;
  text-transform: uppercase;
}

.user-uid span {
  padding-top: 4px;
  display: block;
  color: #304073;
  font-size: 13px;
  font-weight: 400;
}

.user-icon-nav {
  padding: 35px 0;
}

.user-icon-nav li {
  padding: 5px 0;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.user-icon-nav li a {
  color: #6783b8;
  font-size: 15px;
  line-height: 30px;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.user-icon-nav li a .ti,
.user-icon-nav li a .icofont,
.user-icon-nav li a [class*=fa-] {
  width: 35px;
  font-size: 20px;
  line-height: 30px;
  color: #2b56f5;
  text-shadow: 2.121px 2.121px 0.5px rgba(51, 204, 255, 0.2);
}

.user-icon-nav li.active a {
  color: #2b56f5;
  font-weight: 500;
}

.user-icon-nav li:hover a,
.user-icon-nav li:focus a {
  color: #2b56f5;
}

.user-nav {
  padding: 30px 0;
}

.user-nav li {
  padding: 5px 0;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #6783b8;
}

.user-nav li a {
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #6783b8;
  display: block;
}

.user-nav li a:hover {
  color: #2b56f5;
}

.user-nav li span {
  font-weight: 400;
  text-transform: none;
  display: block;
  color: #304073;
  font-size: 13px;
}

.user-nav li.active a {
  color: #2b56f5;
}

.user-ath {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat 50% 50%, #eaf3fc;
  background-size: cover;
}

.user-ath-page {
  display: flex;
  min-height: 100vh;
  align-items: center;
  padding: 40px 0;
}

.user-ath-logo {
  margin-bottom: 25px;
}

.user-ath-box {
  position: relative;
  padding: 45px 40px 40px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
}

.user-ath-box:after {
  position: absolute;
  left: 0;
  top: 0;
  height: 5px;
  width: 100%;
  content: '';
  background: repeating-linear-gradient(90deg, #00bffa 0%, #00bffa 33.34%, #1b57fe 33.35%, #1b57fe 66.68%, #8255fd 66.69%, #8255fd 100%);
  background-size: 50.5%;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.user-ath-form .note {
  margin-bottom: 15px;
}

@media (min-width: 1024px) {
  .user-dashboard {
    padding-top: 90px;
  }

  .user-panel {
    padding: 10px;
  }
}

@media (min-width: 1024px) {
  .user-sidebar {
    width: 220px;
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    box-shadow: none;
    height: auto;
    left: 0;
    padding: 0;
    transition: unset;
    display: block;
    overflow: hidden;
  }

  .user-sidebar-overlay {
    display: none;
  }

  .user-sidebar:before {
    display: none;
  }

  .user-dashboard {
    padding-top: 110px;
  }

  .user-content {
    margin-left: 30px;
  }
}

/** Notification List **/
.notification-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  line-height: 1.4em;
}

.notification-list li:last-child {
  padding-bottom: 0;
}

/** Cards **/
.tile-item {
  border-radius: 4px;
  padding: 34px 20px 30px;
  color: #fff;
  overflow: hidden;
  position: relative;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.tile-item-lastprice {
  height: 120px;
  border-radius: 4px;
  padding: 15px 15px 10px;
  color: #fff;
  overflow: hidden;
  position: relative;
  margin-bottom: 15px;
  box-sizing: border-box;
}

.tile-item-lastprice-diff {
  height: 120px;
  border-radius: 4px;
  padding: 15px 15px 10px;
  text-align: center;
  color: #fff;
  overflow: hidden;
  position: relative;
  margin-bottom: 15px;
  box-sizing: border-box;
}

.tile-bubbles {
  position: absolute;
  left: -25px;
  top: -25px;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.tile-bubbles:before,
.tile-bubbles:after {
  position: absolute;
  content: '';
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.tile-bubbles:before {
  height: 177px;
  width: 177px;
  top: 90px;
  left: -7px;
}

.tile-bubbles:after {
  height: 144px;
  width: 144px;
  top: 60px;
  left: 60px;
}

.tile-primary {
  background: #2b56f5;
}

.tile-light {
  background: #eff6ff;
  border: 2px solid #dce6f5;
  padding: 32px 20px 28px;
}

.tile-title {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 4px;
  letter-spacing: 0.1em;
}

.tile-light .tile-title {
  color: #304073;
}

.tile-info {
  font-weight: 400;
  font-size: 19px;
  margin-bottom: 0;
  letter-spacing: -0.025em;
}

.tile-info-pricediff {
  font-weight: 400;
  font-size: 19px;
  color: #ffa500;
  margin-bottom: 0;
  letter-spacing: -0.025em;
}

.tile-info-small {
  margin: 0 -10px;
  padding-top: 8px;
  color: #6783b8;
  font-size: 16px;
}

.tile-info-list {
  margin: 0 -10px;
  padding-top: 8px;
  color: #6783b8;
  font-size: 12px;
}

.tile-info-list li {
  display: inline-block;
  padding: 0 10px;
  font-weight: 400;
}

.tile-info-list span {
  color: #2b56f5;
  display: block;
  font-size: 19px;
  line-height: 1;
  padding-bottom: 12px;
}

.tile-list-inline {
  margin: 0 -8px;
}

.tile-list-inline li {
  color: #89c3ff;
  display: inline-block;
  padding: 0 8px;
  font-size: 11px;
  line-height: 18px;
}

@media (min-width: 576px) {
  .tile-info {
    font-size: 24px;
  }

  .tile-info-list span {
    font-size: 24px;
  }
}

.info-card {
  margin-bottom: 30px;
  border-radius: 4px;
}

.info-card h4 {
  line-height: 28px;
}

.info-card p {
  font-size: 14px;
  color: #304073;
  margin-bottom: 10px;
}

.info-card p:last-child {
  margin-bottom: 0;
}

.info-card-bordered {
  padding: 15px;
  border: 2px solid #dce6f5;
}

.info-card-image img {
  max-width: 100%;
  width: 200px;
}

@media (min-width: 576px) {
  .info-card-bordered {
    padding: 25px;
  }
}

.last-price {
  border-radius: 6px;
  background: #2b56f5;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  margin-bottom: 20px;
}

.bids-title {
  color: #2b56f5;
  font-weight: 400;
  font-size: 19px;
  letter-spacing: -0.025em;
  margin-left: 5px;
  margin-bottom: 6px;
}

.bids-area-1 {
  height: 100px;
  border: 2px;
  padding: 0px;
  overflow: auto;
}

.bids-area-2 {
  height: 155px;
  border: 2px;
  padding: 0px;
  overflow: auto;
}

.bids-area-n {
  height: 195px;
  border: 2px;
  padding: 0px;
  overflow: auto;
}

.token-card {
  border-radius: 6px;
  background: #6783b8;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  margin-bottom: 30px;
}

.token-info {
  width: 100%;
  flex-grow: 1;
  padding: 20px 10px 20px 50px;
  position: relative;
}

.token-smartag {
  position: absolute;
  color: #fff;
  background: #00d285;
  line-height: 20px;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 30px;
  min-width: 200px;
  text-align: center;
  top: 20px;
  left: -60px;
  transform: rotate(-45deg);
}

.token-bonus {
  color: #fff;
  margin-bottom: 14px;
  padding-left: 25px;
}

.token-bonus span {
  font-size: .5em;
  color: #fff;
}

.token-timeline {
  margin: 0 -16px;
}

.token-timeline li {
  padding: 0 16px;
  font-weight: 500;
  display: inline-block;
  color: #fff;
}

.token-timeline li span {
  display: block;
  font-weight: 600;
  color: #87bfff;
  line-height: 1;
  font-size: 12px;
  letter-spacing: 0.1em;
}

.token-countdown {
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.2);
  padding: 25px;
  text-align: center;
}

.token-countdown-title {
  color: #87bfff;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.1em;
  margin-bottom: 6px;
  display: block;
}

.token-countdown-clock {
  display: flex;
  color: #fff;
}

.token-countdown-clock .countdown-time {
  font-weight: 500;
  font-size: 24px;
  line-height: 1;
}

.token-countdown-clock .countdown-text {
  font-size: 12px;
  line-height: 1;
  display: block;
}

@media (min-width: 576px) {
  .token-info {
    padding: 20px 30px 20px 110px;
  }

  .token-bonus {
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .token-info {
    width: 58%;
    flex-grow: 0;
  }
}

.progress-card {
  border-radius: 4px;
  padding: 20px 15px;
  border: 2px solid #dce6f5;
}

.progress-card h4 {
  margin-bottom: 16px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
}

.progress-info li {
  font-size: 12px;
  font-weight: 500;
}

.progress-info li span {
  color: #304073;
  font-weight: 400;
}

.progress-bar {
  display: block;
  color: #6783b8;
  background: #6a88f8;
  overflow: visible;
  height: 20px;
  border-radius: 3px;
  margin: 45px 0 15px;
  position: relative;
}

.progress-hcap,
.progress-scap,
.progress-psale,
.progress-percent {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  border-radius: 3px;
}

.progress-hcap>div,
.progress-scap>div,
.progress-psale>div,
.progress-percent>div {
  position: absolute;
  right: 0;
  transform: translateX(50%);
  width: 120px;
  font-size: 10px;
  line-height: 14px;
  font-weight: 500;
  padding: 30px 0 0 0;
}

.progress-hcap>div:after,
.progress-scap>div:after,
.progress-psale>div:after,
.progress-percent>div:after {
  position: absolute;
  top: -30px;
  left: 50%;
  margin-left: -2px;
  width: 4px;
  height: 38px;
  content: '';
  background: #6a88f8;
  font-weight: 400;
}

.progress-hcap>div span,
.progress-scap>div span,
.progress-psale>div span,
.progress-percent>div span {
  display: block;
  color: #000;
  position: absolute;
  top: -45px;
  left: 45%;
  font-size: 14px;
}

.progress-hcap {
  background: #aabbfb;
}

.progress-scap {
  background: #8299d3;
}

.progress-psale {
  background: #8299d3;
}

.progress-percent {
  background: #2b56f5;
}

.progress-percent:after {
  position: absolute;
  content: '';
  right: 0;
  top: 50%;
  height: 28px;
  width: 28px;
  border: 3px solid #2b56f5;
  background: #fff;
  border-radius: 50%;
  transform: translate(50%, -50%);
}

@media (min-width: 768px) {
  .progress-card {
    padding: 20px;
  }

  .progress-info li {
    font-size: 14px;
  }

  .progress-hcap>div,
  .progress-scap>div,
  .progress-psale>div,
  .progress-percent>div {
    font-size: 11px;
  }
}

.status {
  padding: 40px 20px;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dce6f5;
}

.status-sm {
  padding: 20px;
}

.status:not(:last-child) {
  margin-bottom: 30px;
}

.status:not(:first-child) {
  margin-top: 10px;
}

.status-icon {
  position: relative;
  height: 80px;
  width: 80px;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  margin: 0 auto 10px;
  border: 2px solid #c8d8f0;
}

.status-icon>.ti {
  color: #c9d9f1;
  font-size: 30px;
  line-height: 76px;
}

.status-icon-sm {
  position: absolute;
  right: -2px;
  bottom: -2px;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ffc7c7;
}

.status-icon-sm>.ti {
  font-size: 12px;
  line-height: 22px;
  color: #ffc7c7;
  display: block;
}

.status-text {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #6783b8;
  letter-spacing: -0.01em;
  padding-bottom: 10px;
}

.status .btn {
  margin-top: 10px;
}

.status-empty .status-icon {
  background: #eff6ff;
  border-color: #c8d8f0;
}

.status-empty .status-icon>.ti {
  color: #c9d9f1;
}

.status-empty .status-icon-sm {
  border-color: #ffc7c7;
}

.status-empty .status-icon-sm>.ti {
  color: #ffc7c7;
}

.status-thank .status-icon,
.status-verified .status-icon {
  border-color: #06d388;
}

.status-thank .status-icon>.ti,
.status-verified .status-icon>.ti {
  color: #06d388;
}

.status-thank .status-icon-sm,
.status-verified .status-icon-sm {
  border-color: #06d388;
}

.status-thank .status-icon-sm>.ti,
.status-verified .status-icon-sm>.ti {
  color: #06d388;
}

.status-verified .status-text {
  color: #06d388;
}

.status-process .status-icon {
  border-color: #50b3ff;
}

.status-process .status-icon>.ti {
  color: #50b3ff;
}

.status-process .status-icon-sm {
  border-color: #50b3ff;
}

.status-process .status-icon-sm>.ti {
  color: #50b3ff;
}

.status-canceled .status-icon {
  border-color: #ffc7c7;
}

.status-canceled .status-icon>.ti {
  color: #ffc7c7;
}

.status-canceled .status-icon-sm {
  border-color: #ffc7c7;
}

.status-canceled .status-icon-sm>.ti {
  color: #ffc7c7;
}

.status-canceled .status-text {
  color: #ffc7c7;
}

.status-warnning .status-icon {
  border-color: #ffd147;
}

.status-warnning .status-icon>.ti {
  color: #ffd147;
}

.status-warnning .status-icon-sm {
  border-color: #ffd147;
}

.status-warnning .status-icon-sm>.ti {
  color: #ffd147;
}

@media (min-width: 576px) {
  .status {
    padding: 50px;
  }

  .status-sm {
    padding: 20px;
  }
}

/** Tabs **/
.nav-tabs-line {
  margin-bottom: 30px;
  border-bottom: 2px solid #d3e0f3;
}

.nav-tabs-line .nav-item {
  padding: 0 12px 0 0;
  margin-bottom: 0;
}

.nav-tabs-line .nav-item:last-child {
  padding: 0;
}

.nav-tabs-line .nav-link {
  border: none;
  padding: 6px 0;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.03em;
  color: rgba(103, 131, 184, 0.7);
  position: relative;
}

.nav-tabs-line .nav-link:after {
  position: absolute;
  left: 0;
  bottom: -2px;
  content: '';
  width: 0;
  height: 2px;
  background: #2b56f5;
  transition: all .4s;
}

.nav-tabs-line .nav-link.active {
  color: #304073;
}

.nav-tabs-line .nav-link.active:after {
  width: 100%;
}

.nav-tabs-bordered {
  display: block;
  margin: 0 -7px;
  border-bottom: 0;
  display: flex;
}

.nav-tabs-bordered .nav-item {
  margin-bottom: 0;
  flex-grow: 1;
  width: 33.33%;
  padding: 0 7px;
  font-weight: 600;
  margin-bottom: 20px;
}

.nav-tabs-bordered .nav-link {
  text-align: center;
  display: block;
  border: 2px solid #d3e0f3;
  border-radius: 4px;
  color: #d3e0f3;
  padding: 12px 0 10px;
  font-size: 11px;
  height: 100%;
}

.nav-tabs-bordered .nav-link.active {
  border: 2px solid #2b56f5;
  color: #2b56f5;
}

.nav-tabs-icon {
  position: relative;
  width: 44px;
  margin: 0 auto 5px;
}

.nav-tabs-icon img {
  transition: all .4s;
  width: 100%;
}

.nav-tabs-icon img:first-of-type {
  opacity: 1;
}

.nav-tabs-icon img:last-of-type {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.active .nav-tabs-icon img:first-of-type {
  opacity: 0;
}

.active .nav-tabs-icon img:last-of-type {
  opacity: 1;
}

@media (min-width: 420px) {
  .nav-tabs-line .nav-item {
    padding: 0 30px 0 0;
  }

  .nav-tabs-line .nav-link {
    font-size: 13px;
    letter-spacing: 0em;
  }
}

@media (min-width: 576px) {
  .nav-tabs-bordered .nav-item {
    padding: 0 15px;
    margin-bottom: 25px;
  }

  .nav-tabs-bordered .nav-link {
    font-size: 14px;
  }

  .nav-tabs-icon {
    width: 64px;
  }
}

@media (min-width: 768px) {
  .nav-tabs-line .nav-item {
    padding: 0 40px 0 0;
  }

  .nav-tabs-line .nav-link {
    font-size: 14px;
  }
}

/** Input Style **/
.input-item {
  padding-bottom: 16px;
}

.input-item-label {
  font-size: 14px;
  font-weight: 500;
  color: #6783b8;
  line-height: 1;
}

.input-bordered {
  border-radius: 4px;
  border: 2px solid #d3e0f3;
  width: 100%;
  padding: 10px 15px;
  line-height: 20px;
  font-size: 14px;
  color: #6783b8;
  transition: all .4s;
}

.input-bordered::-webkit-input-placeholder {
  color: #6783b8;
}

.input-bordered::-moz-placeholder {
  color: #6783b8;
}

.input-bordered:-ms-input-placeholder {
  color: #6783b8;
}

.input-bordered:-moz-placeholder {
  color: #6783b8;
}

.input-bordered:focus {
  box-shadow: none;
  outline: none;
  border-color: #a1cdff;
}

.input-bordered-error {
  border-color: rgba(255, 0, 0, 0.6);
}

.input-switch {
  display: none;
}

.input-switch~label {
  cursor: pointer;
  height: 24px;
  min-width: 50px;
  border-radius: 12px;
  margin-bottom: 0;
  display: block;
  position: relative;
}

.input-switch~label:before,
.input-switch~label:after {
  position: absolute;
  content: '';
  transition: all .4s;
}

.input-switch~label:before {
  left: 0;
  top: 0;
  height: 24px;
  width: 50px;
  border-radius: 12px;
  background: #d3e0f3;
}

.input-switch~label:after {
  left: 3px;
  top: 3px;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: #fff;
}

.input-switch:checked~label:before {
  background: #2b56f5;
}

.input-switch:checked~label:after {
  left: calc(100% - 21px);
}

.input-checkbox {
  display: none;
}

.input-checkbox+label {
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 0;
  color: #6783b8;
  padding-left: 40px;
  position: relative;
  cursor: pointer;
  transition: all .4s;
}

.input-checkbox+label:before,
.input-checkbox+label:after {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 2px;
  transition: all .4s;
}

.input-checkbox+label:before {
  content: '';
  border: 2px solid #d3e0f3;
}

.input-checkbox+label:after {
  line-height: 20px;
  text-align: center;
  font-family: themify;
  content: '\\e64c';
  font-size: 10px;
  font-weight: 900;
  color: #fff;
  background: #2b56f5;
  opacity: 0;
}

.input-checkbox:checked+label:after {
  opacity: 1;
}

.input-note {
  font-size: 12px;
  color: #6783b8;
  opacity: .7;
}

.simple-switch {
  flex-shrink: 0;
  height: 24px;
  width: 50px;
  border-radius: 12px;
  display: inline-block;
  background: #d3e0f3;
  position: relative;
}

.simple-switch:after {
  position: absolute;
  content: '';
  transition: all .4s;
  left: 3px;
  top: 3px;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: #fff;
}

.simple-switch.active {
  background: #2b56f5;
}

.simple-switch.active:after {
  left: calc(100% - 21px);
}

/** DropZone **/
.dz-clickable {
  background: #f3f8ff;
  border: 1px dashed #d3e0f3;
  border-radius: 4px;
  padding: 20px 0 30px;
  text-align: center;
}

.dz-message span {
  display: block;
  color: rgba(103, 131, 184, 0.6);
}

.dz-message-text {
  font-size: 13px;
}

.dz-message-or {
  font-size: 16px;
  margin-bottom: 4px;
}

.dz-preview {
  margin-top: 20px;
  position: relative;
}

.dz-image img {
  border-radius: 4px;
  border: 1px solid #d3e0f3;
}

.dz-filename {
  font-size: 13px;
}

.dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 10px;
  top: 55px;
  left: 50%;
  width: 80px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
  overflow: hidden;
  transition: all .4s;
}

.dz-complete .dz-progress {
  opacity: 0;
}

.dz-upload {
  background: #333;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  transition: all .3s ease-in-out;
}

.dz-error-message,
.dz-success-message {
  font-size: 13px;
}

.dz-error-mark,
.dz-success-mark {
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.dz-error-mark svg,
.dz-success-mark svg {
  height: 40px !important;
  width: 40px !important;
}

.dz-error-mark svg g,
.dz-success-mark svg g {
  stroke-opacity: .7;
  stroke-width: 2;
}

.dz-error-message {
  color: #ff0000;
}

.dz-error-mark g {
  stroke: rgba(255, 0, 0, 0.7) !important;
}

.dz-error .dz-error-mark {
  display: block;
}

.dz-success-message {
  color: #00d285;
}

.dz-success-mark g {
  stroke: rgba(0, 210, 133, 0.7) !important;
}

.dz-success .dz-success-mark {
  display: block;
}

.upload-title {
  color: #6783b8;
  display: block;
  font-size: 14px;
  padding-bottom: 8px;
  font-weight: 500;
}

/** KYC Upload **/
.kyc-upload-title {
  color: #304073;
  margin-bottom: 12px;
}

.kyc-upload-list li {
  color: #304073;
  position: relative;
  padding-left: 25px;
}

.kyc-upload-list li:before {
  position: absolute;
  left: 0;
  top: 3px;
  font-family: Font Awesome;
  content: '\\f00c';
  font-weight: 700;
  color: #9eaecf;
  margin-right: 4px;
  font-size: 13px;
}

.kyc-popup {
  padding: 30px;
}

@media (min-width: 575px) {
  .kyc-upload-img {
    padding: 0 30px 0;
  }

  .kyc-popup {
    padding: 60px;
  }
}

/** Form Style **/
.from-step-item {
  border-bottom: 1px solid #d3e0f3;
}

.from-step-item:last-child {
  border-bottom: none;
}

.from-step-heading {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #d3e0f3;
}

.from-step-number {
  font-size: 20px;
  line-height: 24px;
  padding: 10px 0;
  flex-shrink: 0;
  font-weight: 500;
  color: #9eaecf;
  width: 48px;
  border-radius: 50%;
  text-align: center;
  border: 2px solid;
  margin-right: 15px;
}

.from-step-head h4 {
  margin-bottom: 4px;
  font-weight: 600;
}

.from-step-head p {
  color: #304073;
  font-size: 13px;
}

.from-step-content {
  padding: 20px;
  flex-grow: 1;
}

@media (min-width: 575px) {
  .from-step-heading {
    padding: 30px;
  }

  .from-step-content {
    padding: 30px;
  }
}

/** Payment Box **/
.payment-item {
  text-align: center;
  margin-bottom: 15px;
  position: relative;
}

.payment-item>span {
  display: block;
  font-size: 13px;
  color: #9eaecf;
  line-height: 1;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.payment-item label {
  width: 100%;
  border: 2px solid #d3e0f3;
  border-radius: 4px;
  background: #eff6ff;
  padding: 12px 20px 12px;
  cursor: pointer;
  transition: all .4s;
  position: relative;
  display: flex;
  align-items: center;
}

.payment-item label span {
  padding-left: 15px;
}

.payment-item label:after {
  position: absolute;
  top: -15px;
  right: -15px;
  height: 30px;
  width: 30px;
  line-height: 26px;
  content: '\\f00c';
  font-weight: 600;
  font-size: 12px;
  color: #fff;
  font-family: Font Awesome;
  border-radius: 50%;
  background: #2b56f5;
  border: 3px solid #fff;
  transition: all .4s;
  transform: scale(0);
}

.payment-item input[type="radio"] {
  display: none;
}

.payment-item input[type="radio"]:checked~label {
  border-color: #2b56f5;
}

.payment-item input[type="radio"]:checked~label:after {
  transform: scale(1);
}

.payment-icon {
  margin-bottom: 3px;
}

.payment-icon img {
  width: 30px;
  border-radius: 50%;
}

.payment-icon [class*=fa-] {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.payment-icon-eth img,
.payment-icon-eth [class*=fa-] {
  background: #6d75b7;
}

.payment-icon-ltc img,
.payment-icon-ltc [class*=fa-] {
  background: #bcbcbc;
}

.payment-icon-btc img,
.payment-icon-btc [class*=fa-] {
  background: #fdb722;
}

.payment-icon-usd img,
.payment-icon-usd [class*=fa-] {
  background: #229efd;
}

.payment-cur {
  font-size: 16px;
  color: #304073;
}

.payment-cal-cur {
  position: absolute;
  top: 0;
  right: 0;
  color: #6783b8;
  display: inline-block;
  padding: 8.5px 12px;
}

.payment-cal-cur:after {
  position: absolute;
  left: 0;
  top: 50%;
  height: 24px;
  width: 1px;
  content: '';
  transform: translateY(-50%);
  background: #dce6f5;
}

.payment-calculator {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: -16px 0;
}

.payment-calculator>div {
  padding: 16px 0;
  width: 100%;
}

.payment-calculator .ti {
  position: absolute;
  bottom: 50%;
  color: #304073;
  left: 50%;
  transform: translate(-50%, 50%);
  margin-bottom: -4px;
}

.payment-calculator label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}

.payment-calculator-note {
  font-size: 12px;
}

.payment-calculator-note [class*=fa-] {
  color: #7c98ff;
  margin-right: 5px;
  display: inline-block;
}

.payment-input {
  position: relative;
}

.payment-bonus-title {
  font-weight: 500;
  font-size: 14px;
  color: #6783b8;
  margin-bottom: 2px;
}

.payment-bonus-amount {
  display: block;
  color: #304073;
  font-size: 18px;
}

.payment-bonus-amount span {
  color: #9eaecf;
  font-size: 12px;
}

.payment-bonus-time {
  font-size: 12px;
  color: #6783b8;
  display: block;
  line-height: 1;
}

.payment-summary {
  border-radius: 4px;
  border: 1px solid #dce6f5;
  padding: 20px 18px 0;
  margin-bottom: 30px;
}

.payment-summary-item {
  padding-bottom: 10px;
}

.payment-summary-title {
  color: #2b56f5;
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 500;
}

.payment-summary-info span:first-child:not(.payment-summary-amount) {
  color: #6783b8;
  font-size: 14px;
  font-weight: 400;
  position: relative;
  top: -2px;
}

.payment-summary-info span:last-child {
  font-size: 14px;
  color: #6783b8;
  font-weight: 500;
}

.payment-summary-amount {
  font-size: 20px;
  font-weight: 500;
  color: #304073;
}

@media (min-width: 576px) {
  .payment-calculator {
    margin: 0 -24px;
  }

  .payment-calculator>div {
    padding: 0 24px;
    width: 50%;
  }

  .payment-calculator .ti {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: rotate(-90deg) translate(50%, -50%);
    margin-bottom: 0;
  }

  .payment-item {
    margin-bottom: 30px;
  }

  .payment-item label {
    padding: 20px 20px 10px;
    display: block;
  }

  .payment-item label span {
    padding-left: 0;
  }

  .payment-item>span {
    position: static;
    margin-top: 2px;
    transform: translateY(0);
  }

  .payment-icon img {
    width: 50px;
  }

  .payment-icon [class*=fa-] {
    height: 50px;
    width: 50px;
    line-height: 50px;
    font-size: 20px;
  }
}

@media (min-width: 419px) and (max-width: 575px) {
  .payment-list .col-sm-6 {
    width: 50%;
  }

  .payment-item>span {
    position: static;
    margin-top: 2px;
    transform: translateY(0);
  }
}

/** Data Table **/
table.dataTable {
  width: 100%;
  overflow-x: scroll;
}

.dataTables_filter label {
  margin-bottom: 0;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: center;
}

div.dataTables_wrapper div.dataTables_filter label {
  width: 100%;
  position: relative;
}

div.dataTables_wrapper div.dataTables_filter label:before {
  position: absolute;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 40px;
  font-family: themify;
  content: '\\e610';
  color: #abbbd9;
  font-size: 15px;
}

div.dataTables_wrapper div.dataTables_filter input {
  width: 100%;
  padding: 10px 30px;
  line-height: 20px;
  font-size: 13px;
  border: none;
  background: transparent;
}

div.dataTables_wrapper div.dataTables_filter input:focus {
  border: none;
  background: transparent;
  outline: none;
  box-shadow: none;
}

div.dataTables_wrapper div.dataTables_filter input:-moz-placeholder {
  opacity: 1;
  color: #abbbd9;
}

div.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {
  opacity: 1;
  color: #abbbd9;
}

div.dataTables_wrapper div.dataTables_filter input::-webkit-input-placeholder {
  opacity: 1;
  color: #abbbd9;
}

div.dataTables_wrapper div.dataTables_length {
  text-align: center;
}

div.dataTables_wrapper div.dataTables_length label {
  color: #8599c7;
}

div.dataTables_wrapper div.dataTables_length select {
  margin-left: 10px;
}

div.dataTables_wrapper div.dataTables_info {
  color: #23406c;
  padding: 30px 0 0;
  text-align: center;
}

div.dataTables_wrapper div.dataTables_paginate {
  padding: 20px 0 0;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  justify-content: center;
}

div.dataTables_wrapper>.row>.col-12 {
  padding-left: 5px;
  padding-right: 5px;
}

.clear-table {
  padding-top: 20px;
}

@media (min-width: 576px) {
  div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
  }

  div.dataTables_wrapper div.dataTables_filter input {
    text-align: left;
  }

  div.dataTables_wrapper div.dataTables_length {
    text-align: right;
  }

  div.dataTables_wrapper div.dataTables_info {
    text-align: right;
  }

  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: flex-start;
  }

  div.dataTables_wrapper>.row>.col-12 {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.form-control {
  width: 100%;
  border: none;
}

.page-link {
  padding: 10px 12px;
  margin-left: 0;
  margin: 0 4px;
  text-align: center;
  line-height: 20px;
  min-width: 40px;
  color: #abbbd9;
  background: #eff6ff;
  border: none;
  border-radius: 4px;
}

.page-link:focus {
  box-shadow: none;
}

.page-link:hover {
  color: #6783b8;
  background: #cad2f1;
}

.previous .page-link,
.next .page-link {
  background: #eff6ff;
}

.disabled.previous .page-link,
.disabled.next .page-link {
  display: none;
}

.page-item.active .page-link {
  color: #6783b8;
  background: #cad2f1;
}

.data-filter {
  display: none;
}

.data-filter+label {
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 0;
  color: #6783b8;
  padding-left: 25px;
  position: relative;
  cursor: pointer;
  transition: all .4s;
  opacity: .7;
}

.data-filter+label:before,
.data-filter+label:after {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: 2px;
}

.data-filter+label:before {
  content: '';
  border: 2px solid #6783b8;
}

.data-filter+label:after {
  line-height: 18px;
  text-align: center;
  font-family: themify;
  content: '\\e64c';
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #2b56f5;
  opacity: 0;
}

.data-filter:checked+label {
  opacity: 1;
}

.data-filter:checked+label:after {
  opacity: 1;
}

.data-table {
  border-spacing: 0 5px !important;
}

.data-table-filter a {
  color: #6783b8;
  position: relative;
  top: 5px;
}

.data-table-filter a:hover {
  color: #2b56f5;
}

.data-table-filter .dropdown-menu {
  min-width: auto;
}

.data-table-filter .dropdown-menu li {
  padding: 5px 20px;
}

.data-table thead th {
  line-height: 18px;
  font-weight: 600;
  font-size: 12px;
  color: #6783b8;
  padding: 0 0 6px;
  padding-right: 10px;
}

.data-table thead th:before,
.data-table thead th:after {
  display: none !important;
}

.data-table thead th:first-child {
  padding-left: 20px;
}

.data-table thead th:focus,
.data-table thead th:active {
  box-shadow: none;
  outline: none;
}

.data-table thead th span {
  position: relative;
  display: inline-block;
}

.data-table thead th span:before,
.data-table thead th span:after {
  position: absolute;
  top: 1px;
  opacity: 0.3;
}

.data-table thead th span:before {
  content: '\\2191';
  right: -20px;
}

.data-table thead th span:after {
  content: '\\2193';
  right: -13px;
}

.data-table thead th.sorting_disabled span:before,
.data-table thead th.sorting_disabled span:after {
  display: none;
}

.data-table thead th.sorting_asc span:before {
  opacity: 1;
}

.data-table thead th.sorting_desc span:after {
  opacity: 1;
}

.data-table tbody tr:hover td {
  background: #d5e7ff;
}

.data-table tbody tr.odd td {
  background: #eaf3ff;
}

.data-table tbody tr.even td {
  background: #f4f9ff;
}

.data-table tbody td {
  color: #6783b8;
  font-size: 11px;
  line-height: 1;
  font-weight: 400;
  line-height: 24px;
  padding: 10px 0;
  position: relative;
  transition: all .4s;
}

.data-table tbody td div>span,
.data-table tbody td>span {
  display: block;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: -5px;
  color: #304073;
}

.data-table tbody td:last-child {
  border-radius: 0 3px 3px 0;
}

.data-table tbody td:first-child {
  padding-left: 12px;
  border-radius: 3px 0 0 3px;
}

@media (min-width: 576px) {
  .data-table tbody td {
    font-size: 12px;
    padding: 18px 0;
  }

  .data-table tbody td div>span,
  .data-table tbody td>span {
    font-size: 14px;
  }

  .data-table tbody td:first-child {
    padding-left: 20px;
  }
}

/** Transaction **/
th.tranx-type span {
  padding: 0;
}

.tranx-type span {
  display: inline-block;
  border-radius: 2px;
  font-size: 12px;
  line-height: 22px;
  padding: 0 10px;
}

.tranx-type-purchase {
  background: #9fffdc;
  border: 1px solid #00d285;
}

.tranx-type-bonus {
  background: #d4e8ff;
  border: 1px solid #87bfff;
}

.tranx-type-withdraw {
  background: #fff3cc;
  border: 1px solid #ffc100;
}

.tranx-status {
  width: 20px;
}

.tranx-status .ti {
  height: 24px;
  width: 24px;
  line-height: 22px;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  border: 1px solid;
  display: inline-block;
  background: #fff;
}

.tranx-status-approved .ti {
  color: #00d285;
}

.tranx-status-pending .ti {
  color: #ffc100;
}

.tranx-status-cancled .ti {
  color: #ff0000;
}

.tranx-amount,
.tranx-from {
  display: none;
}

.tranx-action {
  width: 30px;
}

.tranx-action a {
  color: #6783b8;
  height: 30px;
  width: 30px;
  line-height: 34px;
  text-align: center;
  display: inline-block;
  border-radius: 50%;
}

.tranx-action a:hover,
.tranx-action a:focus {
  color: #2b56f5;
  background: #d4e6f9;
}

.tranx-popup {
  padding: 25px;
}

.tranx-popup h5 {
  color: #304073;
  font-weight: 500;
  margin-bottom: 13px;
}

.tranx-popup p {
  font-size: 13px;
  color: #6783b8;
}

.tranx-popup p strong {
  font-weight: 500;
  color: #4b69a1;
}

.tranx-info-list {
  padding: 5px 0 15px;
}

.tranx-info-list li {
  display: inline-block;
  width: 48%;
  font-size: 12px;
  font-weight: 500;
  color: #304073;
}

.tranx-info-list li span {
  color: #6783b8;
  display: inline-block;
  margin-right: 5px;
}

.tranx-info-qr span {
  display: block;
  padding-bottom: 6px;
  padding-bottom: 12px;
  font-size: 13px;
  color: #6783b8;
}

.tranx-info-qrimg {
  width: 120px;
}

.tranx-payment-details.active {
  display: block !important;
}

.tranx-payment-details h6 {
  font-size: 13px;
  color: #304073;
  margin-bottom: 12px;
}

.tranx-payment-info {
  position: relative;
}

.tranx-payment-info>[class*=fa] {
  position: absolute;
  top: 0;
  left: 22px;
  line-height: 20px;
  padding: 15px 0;
  font-size: 14px;
  text-align: center;
  color: #6783b8;
}

.tranx-payment-address {
  border: none;
  color: #6783b8;
  line-height: 20px;
  padding: 15px 40px;
  border-radius: 4px;
  border: 1px solid rgba(211, 224, 243, 0.5);
  width: 100%;
  background: #fff;
}

.tranx-payment-address:focus {
  outline: none;
  box-shadow: none;
}

.tranx-payment-copy {
  position: absolute;
  right: 6px;
  top: 6px;
  height: 40px;
  width: 40px;
  line-height: 20px;
  padding: 10px 0;
  text-align: center;
  color: #6783b8;
  background: #e9eff9;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all .4s;
  /*-- @updated on v1.0.1 --*/
}

.tranx-payment-copy:focus,
.tranx-payment-copy:hover {
  color: #fff;
  background: #2b56f5;
  box-shadow: none;
  outline: none;
}

.tranx-copy-feedback {
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  line-height: 20px;
  padding: 15px 0;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: .05em;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  border: 1px solid rgba(211, 224, 243, 0.5);
  color: #2b56f5;
}

.tranx-purchase-details.active {
  display: block !important;
}

.tranx-purchase-details h6 {
  color: #6783b8;
  font-size: 12px;
  letter-spacing: .2em;
  margin-bottom: 14px;
}

.tranx-purchase-details h6 em {
  padding: 0 7px;
}

.tranx-purchase-details h6 span {
  font-weight: 400;
  text-transform: none;
  color: #6783b8;
  letter-spacing: 0.02em;
}

.tranx-purchase-info {
  border-radius: 6px;
  margin-bottom: 27px;
  border: 1px solid rgba(211, 224, 243, 0.5);
}

.tranx-purchase-info li {
  display: block;
}

.tranx-purchase-info li:last-child .tranx-purchase-des {
  border-bottom: none;
}

.tranx-purchase-head {
  font-size: 13px;
  font-weight: 600;
  color: #6783b8;
  line-height: 20px;
  padding: 14px 20px;
  width: 100%;
}

.tranx-purchase-des {
  font-size: 14px;
  color: #304073;
  line-height: 20px;
  padding: 14px 20px;
  flex-grow: 1;
  border-top: 1px solid rgba(211, 224, 243, 0.5);
  border-bottom: 1px solid rgba(211, 224, 243, 0.5);
  display: flex;
  justify-content: space-between;
}

.tranx-purchase-des span:last-child {
  font-size: 12px;
  color: #6783b8;
}

@media (min-width: 576px) {
  .tranx-popup {
    padding: 45px;
  }

  .tranx-amount,
  .tranx-from {
    display: table-cell;
  }

  .tranx-status {
    width: 35px;
  }

  .tranx-status .ti {
    height: 30px;
    width: 30px;
    line-height: 28px;
    font-size: 14px;
  }

  .tranx-purchase-info li {
    display: flex;
  }

  .tranx-purchase-head {
    width: 185px;
  }

  .tranx-purchase-des {
    border-top: none;
    border-left: 1px solid rgba(211, 224, 243, 0.5);
  }
}

/** Activities **/
.activity-time {
  min-width: 90px;
}

.activity-device {
  display: none;
}

.activity-ip {
  padding-right: 15px !important;
}

@media (min-width: 576px) {
  .activity-time {
    min-width: 120px;
  }

  .activity-device {
    display: block;
  }
}

.refferal-info {
  position: relative;
}

.refferal-info>[class*=fa] {
  position: absolute;
  top: 0;
  left: 18px;
  line-height: 20px;
  padding: 15px 0;
  font-size: 14px;
  text-align: center;
  color: #6783b8;
}

.refferal-address {
  border: none;
  color: #6783b8;
  line-height: 20px;
  padding: 15px 40px;
  border-radius: 4px;
  border: 1px solid rgba(211, 224, 243, 0.5);
  width: 100%;
  background: #fff;
}

.refferal-address:focus {
  outline: none;
  box-shadow: none;
}

.refferal-copy {
  position: absolute;
  right: 6px;
  top: 6px;
  height: 40px;
  width: 40px;
  line-height: 20px;
  padding: 10px 0;
  text-align: center;
  color: #6783b8;
  background: #e9eff9;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all .4s;
  /*-- @updated on v1.0.1 --*/
}

.refferal-copy:focus,
.refferal-copy:hover {
  color: #fff;
  background: #2b56f5;
  box-shadow: none;
  outline: none;
}

.refferal-copy-feedback {
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  line-height: 20px;
  padding: 15px 0;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: .05em;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  border: 1px solid rgba(211, 224, 243, 0.5);
  color: #2b56f5;
}

.refferal-statistics {
  border-radius: 4px;
  border: 1px solid #dce6f5;
  padding: 20px 18px 0;
  margin-bottom: 30px;
}

.refferal-statistics-item {
  padding-bottom: 10px;
}

.refferal-statistics-item h6 {
  color: #2b56f5;
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 500;
}

.refferal-statistics-item span {
  font-size: 20px;
  font-weight: 500;
  color: #304073;
}

.refferal-tokens,
.refferal-channel {
  display: none;
}

@media (min-width: 576px) {

  .refferal-tokens,
  .refferal-channel {
    display: block;
  }
}

.share-links {
  margin: 0 -10px;
}

.share-links li {
  display: inline-block;
  margin: 10px 10px;
  font-size: 14px;
  line-height: 24px;
}

.share-links li a {
  font-size: 17px;
  line-height: 24px;
  display: inline-block;
  color: #6783b8;
}

.share-links li a:hover {
  color: #2b56f5;
}

/** Author Info **/
.ath-trigger {
  display: flex;
  align-items: center;
  color: #6783b8;
  line-height: 1.4em;
}

.ath-trigger:hover,
.ath-trigger:active,
.ath-trigger:focus,
.ath-trigger.active {
  color: #6783b8;
}

.ath-trigger span {
  margin-right: 16px;
}

.ath-content {
  display: none;
}

.ath-content h5 {
  color: #6783b8;
  margin-bottom: 8px;
  margin-top: 0;
}

.ath-content-sublist {
  padding: 0 0 20px 5px;
}

.ath-content-sublist li {
  color: #6783b8;
  font-size: 12px;
  padding-bottom: 4px;
}

.ath-content-sublist li:before {
  content: '-';
  margin-right: 5px;
}

.ath-content-sublist li:last-child {
  padding-bottom: 0;
}

.ath-content-qrimg {
  width: 120px;
  margin-bottom: 5px;
}

/** Datepicker **/
.datepicker-dropdown.datepicker-orient-bottom:before {
  bottom: -8px;
  border-top: 6px solid #a6cffd;
}

.datepicker-dropdown.datepicker-orient-top:before {
  top: -8px;
  border-bottom: 6px solid #a6cffd;
}

.datepicker.dropdown-menu {
  border: none;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border: 2px solid #a6cffd;
}

.datepicker.dropdown-menu td {
  padding: 7px 8px;
  min-width: 35px;
}

.datepicker table thead tr th {
  transition: all .4s;
  color: #3c3c3c;
}

.datepicker table thead tr th:hover {
  background: #eaf3fc !important;
}

.datepicker table tr th {
  transition: all .4s;
}

.datepicker table tr td {
  transition: all .4s;
  color: #8599c6;
}

.datepicker table tr td.day:hover {
  background: #eaf3fc;
}

.datepicker table tr td.old,
.datepicker table tr td.new {
  color: rgba(133, 153, 198, 0.4);
}

.datepicker table tr td.today {
  background: #46bdf4;
  color: #fff;
}

.datepicker table tr td.today:hover:hover {
  color: #fff;
  background: #2b56f5;
}

.datepicker table tr td.active.active {
  background: #2b56f5;
  color: #fff;
}

.datepicker table tr td.active.active:hover:hover {
  color: #fff;
  background: #2b56f5;
}

.datepicker table tr td span {
  transition: all .4s;
}

.datepicker table tr td span:hover {
  background: #eaf3fc;
}

.datepicker table tr td span.active.active {
  background: #2b56f5;
  color: #fff;
}

.datepicker table tr td span.active.active:hover:hover {
  color: #fff;
  background: #2b56f5;
}

.footer-bar {
  font-size: 13px;
  padding: 20px 0;
  color: #6783b8;
}

.footer-bar a {
  color: #6783b8;
}

.footer-bar a:hover,
.footer-bar a:focus {
  color: #2b56f5;
}

.footer-copyright {
  display: block;
  padding: 15px 0 0;
}

.footer-links {
  padding: 15px 0;
  margin: 0 -5px;
}

.footer-links li {
  padding: 0 5px;
  display: inline-block;
  position: relative;
}

.footer-links li:after {
  position: absolute;
  right: -3px;
  top: 0;
  content: '|';
  color: #6783b8;
}

.footer-links li:last-child:after {
  content: '';
}

@media (min-width: 768px) {
  .footer-bar {
    padding: 40px 0 20px;
  }

  .footer-copyright {
    padding: 15px 0;
  }
}

/** END */
.container {
  white-space: pre-line;
}

.language-Type {
  margin: 0 1px 0 10px;
  text-align: left;
  align-items: left;
}

.payment-Type {
  margin: 0 1px 0 10px;
}

.partialexecution-Flag {
  margin: 0 1px 0 10px;
}

.orderOption-Type {
  margin: 0 1px 0 10px;
}

.bids-list-box {
  border-radius: 4px;
  padding: 10px 5px;
  border: 2px solid #dce6f5;
}

.table th {
  background: #fff;
  padding: 8px 10px;
  border-bottom: 1px solid #1a1a1a;
  font-weight: bold;
  text-align: left;
}

.table th.up {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.table th.down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.table th.default {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

th.up,
th.default,
th.down {
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center right;
}

.td-wrap-text {
  word-break: break-all;
}

.tr-type1 {
  border: 1px solid grey;
}

.td-type1-col1 {
  padding: 10px 10px;
  width: 35%;
  background: lightgrey;
  color: black;
  font-weight: 600;
  font-size: 14px;
  line-height: 2;
  padding-top: 5px;
  text-align: left;
}

.td-type1-col2 {
  padding: 10px 10px;
  width: 65%;
  background: white;
  color: black;
  font-weight: 600;
  font-size: 14px;
  line-height: 2;
  padding-top: 5px;
  text-align: left;
}

.td-type2-col1 {
  padding: 10px 10px;
  width: 40%;
  color: black;
  font-weight: 600;
  font-size: 13px;
  line-height: 2;
  padding-top: 5px;
  text-align: left;
  word-break: break-all;
}

.td-type2-col2 {
  padding: 10px 10px;
  width: 60%;
  color: black;
  font-weight: 600;
  font-size: 13px;
  line-height: 2;
  padding-top: 5px;
  text-align: left;
  word-break: normal;
}

.SubMenu {
  margin-left: 15px
}

.SubMenuText {
  margin-left: 0px
}

.TopMenuIcon {
  margin-left: 25px;
  align-items: right;
  text-align: right;
}

.Message-Red {
  color: red;
  font-weight: 400;
}

.Message-Blue {
  color: blue;
  font-weight: 400;
}

.Right-Align {
  align-items: right;
  text-align: right;
}

.withdraw-panel {
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  min-height: 100%;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
}

.adminTable {
  border: 1px solid black;
  border-collapse: collapse;
  margin-bottom: 12px;
  line-height: 1.68;
}

.adminTR {
  border: 1px solid black;
  border-collapse: collapse;
}

.adminTH {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  color: #fff;
  background-color: #bebdbd;
}

.adminTD {
  border: 1px solid black;
  border-collapse: collapse;
  word-break: break-all;
  font-weight: 500;
  font-size: 12px;
}

.adminTDError {
  border: 1px solid black;
  border-collapse: collapse;
  word-break: break-all;
  font-weight: 500;
  font-size: 12px;
  color: #ff0000;
}

.imgThumbnail {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
}

/* Pagination styling */
.pagination {
  display: flex;
  justify-content: center;
  padding-left: 0;
  list-style: none;
  margin-top: 20px;
}

.pagination li {
  margin: 0 5px;
}

.pagination li a {
  display: inline-block;
  padding: 10px 15px;
  background-color: white;
  color: #007bff;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.pagination li a:hover {
  background-color: #007bff;
  color: white;
}

.pagination li.active a {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD,8FAA8F;AAC9F,kBAAkB;AAClB;EACE,sBAAsB;EACtB,4CAAqC;EACrC,mSAAiR;EACjR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAAsC;EACtC,qSAAuR;EACvR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAyC;EACzC,+SAAyS;EACzS,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAuC;EACvC,2SAA6R;EAC7R,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAwC;EACxC,6SAAmS;EACnS,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;;;;EAUE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,OAAO;EACP,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,MAAM;EACN,wBAAwB;EACxB,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,eAAe;EACf,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA,cAAc;AACd;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,MAAM;EACN,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,+CAA+C;EAC/C,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,8CAA8C;EAC9C,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+EAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,sIAAsI;EACtI,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,OAAO;IACP,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,8CAA8C;IAC9C,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,MAAM;EACN,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,iDAAiD;EACjD,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,+CAA+C;EACjD;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,MAAM;EACN,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0DAA+C;AACjD;;AAEA;EACE,0DAAiD;AACnD;;AAEA;EACE,0DAA8C;AAChD;;AAEA;;;EAGE,eAAe;EACf,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":["/*!\nTemplate :\tUserCenter - ICO Crypto\nAuthor\t :\tSoftnio\nVersion\t :\t1.0.1\nUpdated\t :\t10.23.2022\n*/\n/*! Table of Contents 01.0 - Fonts 02.0 - Reset 03.0 - Utility 04.0 - Common 05.0 - Elements */\n/*! 01.0 - FONTS */\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"../fonts/Poppins-Bold.eot\");\n  src: local(\"Poppins Bold\"), local(\"Poppins-Bold\"), url(\"../fonts/Poppins-Bold.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/Poppins-Bold.woff2\") format(\"woff2\"), url(\"../fonts/Poppins-Bold.woff\") format(\"woff\"), url(\"../fonts/Poppins-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"../fonts/Poppins-Light.eot\");\n  src: local(\"Poppins Light\"), local(\"Poppins-Light\"), url(\"../fonts/Poppins-Light.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/Poppins-Light.woff2\") format(\"woff2\"), url(\"../fonts/Poppins-Light.woff\") format(\"woff\"), url(\"../fonts/Poppins-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"../fonts/Poppins-SemiBold.eot\");\n  src: local(\"Poppins SemiBold\"), local(\"Poppins-SemiBold\"), url(\"../fonts/Poppins-SemiBold.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/Poppins-SemiBold.woff2\") format(\"woff2\"), url(\"../fonts/Poppins-SemiBold.woff\") format(\"woff\"), url(\"../fonts/Poppins-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"../fonts/Poppins-Medium.eot\");\n  src: local(\"Poppins Medium\"), local(\"Poppins-Medium\"), url(\"../fonts/Poppins-Medium.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/Poppins-Medium.woff2\") format(\"woff2\"), url(\"../fonts/Poppins-Medium.woff\") format(\"woff\"), url(\"../fonts/Poppins-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"../fonts/Poppins-Regular.eot\");\n  src: local(\"Poppins Regular\"), local(\"Poppins-Regular\"), url(\"../fonts/Poppins-Regular.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/Poppins-Regular.woff2\") format(\"woff2\"), url(\"../fonts/Poppins-Regular.woff\") format(\"woff\"), url(\"../fonts/Poppins-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*! 02.0 - RESET */\nbody {\n  font-family: \"Poppins\", sans-serif;\n  color: #3c3c3c;\n  font-size: 14px;\n  line-height: 1.86;\n  font-weight: 300;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: relative;\n  background: #eaf3fc;\n  min-width: 320px;\n  color: #6783b8;\n}\n\nimg {\n  max-width: 100%;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul:not(.btn-grp),\nol,\ntable {\n  margin-bottom: 12px;\n  line-height: 1.68;\n}\n\nh1:last-child,\nh2:last-child,\nh3:last-child,\nh4:last-child,\nh5:last-child,\nh6:last-child,\np:last-child,\nul:not(.btn-grp):last-child,\nol:last-child,\ntable:last-child {\n  margin-bottom: 0;\n}\n\nh1,\n.h1 {\n  font-size: 1.75em;\n}\n\nh2,\n.h2 {\n  font-size: 1.58em;\n}\n\nh3,\n.h3 {\n  font-size: 1.32em;\n}\n\nh4,\n.h4 {\n  font-size: 1.2em;\n}\n\nh5,\n.h5 {\n  font-size: 1em;\n}\n\nh6,\n.h6 {\n  font-size: .9em;\n}\n\np {\n  font-size: 1em;\n}\n\np.lead {\n  font-size: 1.27em;\n}\n\nh1 span,\nh2 span,\nh3 span,\nh4 span,\nh5 span,\nh6 span,\np span {\n  color: #2b56f5;\n}\n\nul,\nol {\n  padding: 0px;\n  margin: 0px;\n}\n\nul li,\nol li {\n  list-style: none;\n}\n\n.relative {\n  position: relative;\n}\n\np+h1,\np+h2,\np+h3,\np+h4,\np+h5,\np+h4,\nul+h1,\nul+h2,\nul+h3,\nul+h4,\nul+h5,\nul+h4,\nol+h1,\nol+h2,\nol+h3,\nol+h4,\nol+h5,\nol+h4,\ntable+h1,\ntable+h2,\ntable+h3,\ntable+h4,\ntable+h5,\ntable+h4 {\n  margin-top: 35px;\n}\n\nul+p,\nul+ul,\nul+ol,\nol+ol,\nol+ul,\nul+table,\nol+table {\n  margin-top: 35px;\n}\n\nb,\nstrong {\n  font-weight: 600;\n}\n\na {\n  outline: 0;\n  transition: all 0.5s;\n  color: #2b56f5;\n}\n\na:link,\na:visited {\n  text-decoration: none;\n}\n\na:hover,\na:focus,\na:active {\n  outline: 0;\n  color: #46bdf4;\n}\n\n.container {\n  z-index: 5;\n}\n\n@media (min-width: 1090px) {\n  .container {\n    width: 1080px;\n  }\n}\n\n/*! 03.0 - UTILITY */\n.ucap {\n  text-transform: uppercase;\n}\n\n.cap {\n  text-transform: capitalize;\n}\n\n.pad-0,\n.nopd {\n  padding: 0px;\n}\n\n.npl {\n  padding-left: 0px;\n}\n\n.npr {\n  padding-right: 0px;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.sap {\n  width: 100%;\n  height: 1px;\n  margin: 20px 0;\n  background: #edf5ff;\n}\n\n.gaps-1x {\n  height: 10px;\n}\n\n.gaps-2x {\n  height: 20px;\n}\n\n.gaps-3x {\n  height: 30px;\n}\n\n.gaps-4x {\n  height: 40px;\n}\n\n.gaps-5x {\n  height: 50px;\n}\n\n.gaps-6x {\n  height: 60px;\n}\n\n.gaps-7x {\n  height: 70px;\n}\n\n.gaps-8x {\n  height: 80px;\n}\n\n.gaps-9x {\n  height: 90px;\n}\n\n.gaps-10x {\n  height: 100px;\n}\n\n.gaps-11x {\n  height: 110px;\n}\n\n.gaps-12x {\n  height: 120px;\n}\n\n.gaps-13x {\n  height: 130px;\n}\n\n.gaps-14x {\n  height: 140px;\n}\n\n.gaps-15x {\n  height: 150px;\n}\n\n.gaps-16x {\n  height: 160px;\n}\n\n.gaps-17x {\n  height: 170px;\n}\n\n.gaps-18x {\n  height: 180px;\n}\n\n.gaps-19x {\n  height: 190px;\n}\n\n.gaps-20x {\n  height: 200px;\n}\n\n.padl-1x {\n  padding-left: 10px;\n}\n\n.padl-2x {\n  padding-left: 20px;\n}\n\n.padl-3x {\n  padding-left: 30px;\n}\n\n.padl-4x {\n  padding-left: 40px;\n}\n\n.padl-5x {\n  padding-left: 50px;\n}\n\n.padl-6x {\n  padding-left: 60px;\n}\n\n.padl-7x {\n  padding-left: 70px;\n}\n\n.padl-8x {\n  padding-left: 80px;\n}\n\n.padl-9x {\n  padding-left: 90px;\n}\n\n.padl-10x {\n  padding-left: 100px;\n}\n\n.padl-11x {\n  padding-left: 110px;\n}\n\n.padl-12x {\n  padding-left: 120px;\n}\n\n.padl-13x {\n  padding-left: 130px;\n}\n\n.padl-14x {\n  padding-left: 140px;\n}\n\n.padl-15x {\n  padding-left: 150px;\n}\n\n.padl-16x {\n  padding-left: 160px;\n}\n\n.padl-17x {\n  padding-left: 170px;\n}\n\n.padl-18x {\n  padding-left: 180px;\n}\n\n.padl-19x {\n  padding-left: 190px;\n}\n\n.padl-20x {\n  padding-left: 200px;\n}\n\n.w1 {\n  width: 1%;\n}\n\n.w2 {\n  width: 2%;\n}\n\n.w3 {\n  width: 3%;\n}\n\n.w4 {\n  width: 4%;\n}\n\n.w5 {\n  width: 5%;\n}\n\n.w6 {\n  width: 6%;\n}\n\n.w7 {\n  width: 7%;\n}\n\n.w8 {\n  width: 8%;\n}\n\n.w9 {\n  width: 9%;\n}\n\n.w10 {\n  width: 10%;\n}\n\n.w11 {\n  width: 11%;\n}\n\n.w12 {\n  width: 12%;\n}\n\n.w13 {\n  width: 13%;\n}\n\n.w14 {\n  width: 14%;\n}\n\n.w15 {\n  width: 15%;\n}\n\n.w16 {\n  width: 16%;\n}\n\n.w17 {\n  width: 17%;\n}\n\n.w18 {\n  width: 18%;\n}\n\n.w19 {\n  width: 19%;\n}\n\n.w20 {\n  width: 20%;\n}\n\n.w21 {\n  width: 21%;\n}\n\n.w22 {\n  width: 22%;\n}\n\n.w23 {\n  width: 23%;\n}\n\n.w24 {\n  width: 24%;\n}\n\n.w25 {\n  width: 25%;\n}\n\n.w26 {\n  width: 26%;\n}\n\n.w27 {\n  width: 27%;\n}\n\n.w28 {\n  width: 28%;\n}\n\n.w29 {\n  width: 29%;\n}\n\n.w30 {\n  width: 30%;\n}\n\n.w31 {\n  width: 31%;\n}\n\n.w32 {\n  width: 32%;\n}\n\n.w33 {\n  width: 33%;\n}\n\n.w34 {\n  width: 34%;\n}\n\n.w35 {\n  width: 35%;\n}\n\n.w36 {\n  width: 36%;\n}\n\n.w37 {\n  width: 37%;\n}\n\n.w38 {\n  width: 38%;\n}\n\n.w39 {\n  width: 39%;\n}\n\n.w40 {\n  width: 40%;\n}\n\n.w41 {\n  width: 41%;\n}\n\n.w42 {\n  width: 42%;\n}\n\n.w43 {\n  width: 43%;\n}\n\n.w44 {\n  width: 44%;\n}\n\n.w45 {\n  width: 45%;\n}\n\n.w46 {\n  width: 46%;\n}\n\n.w47 {\n  width: 47%;\n}\n\n.w48 {\n  width: 48%;\n}\n\n.w49 {\n  width: 49%;\n}\n\n.w50 {\n  width: 50%;\n}\n\n.w51 {\n  width: 51%;\n}\n\n.w52 {\n  width: 52%;\n}\n\n.w53 {\n  width: 53%;\n}\n\n.w54 {\n  width: 54%;\n}\n\n.w55 {\n  width: 55%;\n}\n\n.w56 {\n  width: 56%;\n}\n\n.w57 {\n  width: 57%;\n}\n\n.w58 {\n  width: 58%;\n}\n\n.w59 {\n  width: 59%;\n}\n\n.w60 {\n  width: 60%;\n}\n\n.w61 {\n  width: 61%;\n}\n\n.w62 {\n  width: 62%;\n}\n\n.w63 {\n  width: 63%;\n}\n\n.w64 {\n  width: 64%;\n}\n\n.w65 {\n  width: 65%;\n}\n\n.w66 {\n  width: 66%;\n}\n\n.w67 {\n  width: 67%;\n}\n\n.w68 {\n  width: 68%;\n}\n\n.w69 {\n  width: 69%;\n}\n\n.w70 {\n  width: 70%;\n}\n\n.w71 {\n  width: 71%;\n}\n\n.w72 {\n  width: 72%;\n}\n\n.w73 {\n  width: 73%;\n}\n\n.w74 {\n  width: 74%;\n}\n\n.w75 {\n  width: 75%;\n}\n\n.w76 {\n  width: 76%;\n}\n\n.w77 {\n  width: 77%;\n}\n\n.w78 {\n  width: 78%;\n}\n\n.w79 {\n  width: 79%;\n}\n\n.w80 {\n  width: 80%;\n}\n\n.w81 {\n  width: 81%;\n}\n\n.w82 {\n  width: 82%;\n}\n\n.w83 {\n  width: 83%;\n}\n\n.w84 {\n  width: 84%;\n}\n\n.w85 {\n  width: 85%;\n}\n\n.w86 {\n  width: 86%;\n}\n\n.w87 {\n  width: 87%;\n}\n\n.w88 {\n  width: 88%;\n}\n\n.w89 {\n  width: 89%;\n}\n\n.w90 {\n  width: 90%;\n}\n\n.w91 {\n  width: 91%;\n}\n\n.w92 {\n  width: 92%;\n}\n\n.w93 {\n  width: 93%;\n}\n\n.w94 {\n  width: 94%;\n}\n\n.w95 {\n  width: 95%;\n}\n\n.w96 {\n  width: 96%;\n}\n\n.w97 {\n  width: 97%;\n}\n\n.w98 {\n  width: 98%;\n}\n\n.w99 {\n  width: 99%;\n}\n\n.w100 {\n  width: 100%;\n}\n\n.w1px {\n  width: 1px;\n}\n\n.w2px {\n  width: 2px;\n}\n\n.w3px {\n  width: 3px;\n}\n\n.w4px {\n  width: 4px;\n}\n\n.w5px {\n  width: 5px;\n}\n\n.w6px {\n  width: 6px;\n}\n\n.w7px {\n  width: 7px;\n}\n\n.w8px {\n  width: 8px;\n}\n\n.w9px {\n  width: 9px;\n}\n\n.w10px {\n  width: 10px;\n}\n\n.w11px {\n  width: 11px;\n}\n\n.w12px {\n  width: 12px;\n}\n\n.w13px {\n  width: 13px;\n}\n\n.w14px {\n  width: 14px;\n}\n\n.w15px {\n  width: 15px;\n}\n\n.w16px {\n  width: 16px;\n}\n\n.w17px {\n  width: 17px;\n}\n\n.w18px {\n  width: 18px;\n}\n\n.w19px {\n  width: 19px;\n}\n\n.w20px {\n  width: 20px;\n}\n\n.w21px {\n  width: 21px;\n}\n\n.w22px {\n  width: 22px;\n}\n\n.w23px {\n  width: 23px;\n}\n\n.w24px {\n  width: 24px;\n}\n\n.w25px {\n  width: 25px;\n}\n\n.w26px {\n  width: 26px;\n}\n\n.w27px {\n  width: 27px;\n}\n\n.w28px {\n  width: 28px;\n}\n\n.w29px {\n  width: 29px;\n}\n\n.w30px {\n  width: 30px;\n}\n\n.w31px {\n  width: 31px;\n}\n\n.w32px {\n  width: 32px;\n}\n\n.w33px {\n  width: 33px;\n}\n\n.w34px {\n  width: 34px;\n}\n\n.w35px {\n  width: 35px;\n}\n\n.w36px {\n  width: 36px;\n}\n\n.w37px {\n  width: 37px;\n}\n\n.w38px {\n  width: 38px;\n}\n\n.w39px {\n  width: 39px;\n}\n\n.w40px {\n  width: 40px;\n}\n\n.w41px {\n  width: 41px;\n}\n\n.w42px {\n  width: 42px;\n}\n\n.w43px {\n  width: 43px;\n}\n\n.w44px {\n  width: 44px;\n}\n\n.w45px {\n  width: 45px;\n}\n\n.w46px {\n  width: 46px;\n}\n\n.w47px {\n  width: 47px;\n}\n\n.w48px {\n  width: 48px;\n}\n\n.w49px {\n  width: 49px;\n}\n\n.w50px {\n  width: 50px;\n}\n\n.w51px {\n  width: 51px;\n}\n\n.w52px {\n  width: 52px;\n}\n\n.w53px {\n  width: 53px;\n}\n\n.w54px {\n  width: 54px;\n}\n\n.w55px {\n  width: 55px;\n}\n\n.w56px {\n  width: 56px;\n}\n\n.w57px {\n  width: 57px;\n}\n\n.w58px {\n  width: 58px;\n}\n\n.w59px {\n  width: 59px;\n}\n\n.w60px {\n  width: 60px;\n}\n\n.w61px {\n  width: 61px;\n}\n\n.w62px {\n  width: 62px;\n}\n\n.w63px {\n  width: 63px;\n}\n\n.w64px {\n  width: 64px;\n}\n\n.w65px {\n  width: 65px;\n}\n\n.w66px {\n  width: 66px;\n}\n\n.w67px {\n  width: 67px;\n}\n\n.w68px {\n  width: 68px;\n}\n\n.w69px {\n  width: 69px;\n}\n\n.w70px {\n  width: 70px;\n}\n\n.w71px {\n  width: 71px;\n}\n\n.w72px {\n  width: 72px;\n}\n\n.w73px {\n  width: 73px;\n}\n\n.w74px {\n  width: 74px;\n}\n\n.w75px {\n  width: 75px;\n}\n\n.w76px {\n  width: 76px;\n}\n\n.w77px {\n  width: 77px;\n}\n\n.w78px {\n  width: 78px;\n}\n\n.w79px {\n  width: 79px;\n}\n\n.w80px {\n  width: 80px;\n}\n\n.w81px {\n  width: 81px;\n}\n\n.w82px {\n  width: 82px;\n}\n\n.w83px {\n  width: 83px;\n}\n\n.w84px {\n  width: 84px;\n}\n\n.w85px {\n  width: 85px;\n}\n\n.w86px {\n  width: 86px;\n}\n\n.w87px {\n  width: 87px;\n}\n\n.w88px {\n  width: 88px;\n}\n\n.w89px {\n  width: 89px;\n}\n\n.w90px {\n  width: 90px;\n}\n\n.w91px {\n  width: 91px;\n}\n\n.w92px {\n  width: 92px;\n}\n\n.w93px {\n  width: 93px;\n}\n\n.w94px {\n  width: 94px;\n}\n\n.w95px {\n  width: 95px;\n}\n\n.w96px {\n  width: 96px;\n}\n\n.w97px {\n  width: 97px;\n}\n\n.w98px {\n  width: 98px;\n}\n\n.w99px {\n  width: 99px;\n}\n\n.w100px {\n  width: 100px;\n}\n\n.wauto {\n  width: auto;\n}\n\n.hauto {\n  height: auto;\n}\n\n.vh100 {\n  height: 100vh;\n}\n\n.guttar-1px {\n  margin-left: -0.5px;\n  margin-right: -0.5px;\n}\n\n.guttar-1px>li,\n.guttar-1px>div {\n  padding-left: 0.5px;\n  padding-right: 0.5px;\n}\n\n.guttar-2px {\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.guttar-2px>li,\n.guttar-2px>div {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n.guttar-3px {\n  margin-left: -1.5px;\n  margin-right: -1.5px;\n}\n\n.guttar-3px>li,\n.guttar-3px>div {\n  padding-left: 1.5px;\n  padding-right: 1.5px;\n}\n\n.guttar-4px {\n  margin-left: -2px;\n  margin-right: -2px;\n}\n\n.guttar-4px>li,\n.guttar-4px>div {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.guttar-5px {\n  margin-left: -2.5px;\n  margin-right: -2.5px;\n}\n\n.guttar-5px>li,\n.guttar-5px>div {\n  padding-left: 2.5px;\n  padding-right: 2.5px;\n}\n\n.guttar-6px {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n\n.guttar-6px>li,\n.guttar-6px>div {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.guttar-7px {\n  margin-left: -3.5px;\n  margin-right: -3.5px;\n}\n\n.guttar-7px>li,\n.guttar-7px>div {\n  padding-left: 3.5px;\n  padding-right: 3.5px;\n}\n\n.guttar-8px {\n  margin-left: -4px;\n  margin-right: -4px;\n}\n\n.guttar-8px>li,\n.guttar-8px>div {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.guttar-9px {\n  margin-left: -4.5px;\n  margin-right: -4.5px;\n}\n\n.guttar-9px>li,\n.guttar-9px>div {\n  padding-left: 4.5px;\n  padding-right: 4.5px;\n}\n\n.guttar-10px {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.guttar-10px>li,\n.guttar-10px>div {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.guttar-11px {\n  margin-left: -5.5px;\n  margin-right: -5.5px;\n}\n\n.guttar-11px>li,\n.guttar-11px>div {\n  padding-left: 5.5px;\n  padding-right: 5.5px;\n}\n\n.guttar-12px {\n  margin-left: -6px;\n  margin-right: -6px;\n}\n\n.guttar-12px>li,\n.guttar-12px>div {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.guttar-13px {\n  margin-left: -6.5px;\n  margin-right: -6.5px;\n}\n\n.guttar-13px>li,\n.guttar-13px>div {\n  padding-left: 6.5px;\n  padding-right: 6.5px;\n}\n\n.guttar-14px {\n  margin-left: -7px;\n  margin-right: -7px;\n}\n\n.guttar-14px>li,\n.guttar-14px>div {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\n.guttar-15px {\n  margin-left: -7.5px;\n  margin-right: -7.5px;\n}\n\n.guttar-15px>li,\n.guttar-15px>div {\n  padding-left: 7.5px;\n  padding-right: 7.5px;\n}\n\n.guttar-16px {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n\n.guttar-16px>li,\n.guttar-16px>div {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.guttar-17px {\n  margin-left: -8.5px;\n  margin-right: -8.5px;\n}\n\n.guttar-17px>li,\n.guttar-17px>div {\n  padding-left: 8.5px;\n  padding-right: 8.5px;\n}\n\n.guttar-18px {\n  margin-left: -9px;\n  margin-right: -9px;\n}\n\n.guttar-18px>li,\n.guttar-18px>div {\n  padding-left: 9px;\n  padding-right: 9px;\n}\n\n.guttar-19px {\n  margin-left: -9.5px;\n  margin-right: -9.5px;\n}\n\n.guttar-19px>li,\n.guttar-19px>div {\n  padding-left: 9.5px;\n  padding-right: 9.5px;\n}\n\n.guttar-20px {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.guttar-20px>li,\n.guttar-20px>div {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.guttar-21px {\n  margin-left: -10.5px;\n  margin-right: -10.5px;\n}\n\n.guttar-21px>li,\n.guttar-21px>div {\n  padding-left: 10.5px;\n  padding-right: 10.5px;\n}\n\n.guttar-22px {\n  margin-left: -11px;\n  margin-right: -11px;\n}\n\n.guttar-22px>li,\n.guttar-22px>div {\n  padding-left: 11px;\n  padding-right: 11px;\n}\n\n.guttar-23px {\n  margin-left: -11.5px;\n  margin-right: -11.5px;\n}\n\n.guttar-23px>li,\n.guttar-23px>div {\n  padding-left: 11.5px;\n  padding-right: 11.5px;\n}\n\n.guttar-24px {\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.guttar-24px>li,\n.guttar-24px>div {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.guttar-25px {\n  margin-left: -12.5px;\n  margin-right: -12.5px;\n}\n\n.guttar-25px>li,\n.guttar-25px>div {\n  padding-left: 12.5px;\n  padding-right: 12.5px;\n}\n\n.guttar-26px {\n  margin-left: -13px;\n  margin-right: -13px;\n}\n\n.guttar-26px>li,\n.guttar-26px>div {\n  padding-left: 13px;\n  padding-right: 13px;\n}\n\n.guttar-27px {\n  margin-left: -13.5px;\n  margin-right: -13.5px;\n}\n\n.guttar-27px>li,\n.guttar-27px>div {\n  padding-left: 13.5px;\n  padding-right: 13.5px;\n}\n\n.guttar-28px {\n  margin-left: -14px;\n  margin-right: -14px;\n}\n\n.guttar-28px>li,\n.guttar-28px>div {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n.guttar-29px {\n  margin-left: -14.5px;\n  margin-right: -14.5px;\n}\n\n.guttar-29px>li,\n.guttar-29px>div {\n  padding-left: 14.5px;\n  padding-right: 14.5px;\n}\n\n.guttar-30px {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.guttar-30px>li,\n.guttar-30px>div {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.guttar-31px {\n  margin-left: -15.5px;\n  margin-right: -15.5px;\n}\n\n.guttar-31px>li,\n.guttar-31px>div {\n  padding-left: 15.5px;\n  padding-right: 15.5px;\n}\n\n.guttar-32px {\n  margin-left: -16px;\n  margin-right: -16px;\n}\n\n.guttar-32px>li,\n.guttar-32px>div {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.guttar-33px {\n  margin-left: -16.5px;\n  margin-right: -16.5px;\n}\n\n.guttar-33px>li,\n.guttar-33px>div {\n  padding-left: 16.5px;\n  padding-right: 16.5px;\n}\n\n.guttar-34px {\n  margin-left: -17px;\n  margin-right: -17px;\n}\n\n.guttar-34px>li,\n.guttar-34px>div {\n  padding-left: 17px;\n  padding-right: 17px;\n}\n\n.guttar-35px {\n  margin-left: -17.5px;\n  margin-right: -17.5px;\n}\n\n.guttar-35px>li,\n.guttar-35px>div {\n  padding-left: 17.5px;\n  padding-right: 17.5px;\n}\n\n.guttar-36px {\n  margin-left: -18px;\n  margin-right: -18px;\n}\n\n.guttar-36px>li,\n.guttar-36px>div {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n.guttar-37px {\n  margin-left: -18.5px;\n  margin-right: -18.5px;\n}\n\n.guttar-37px>li,\n.guttar-37px>div {\n  padding-left: 18.5px;\n  padding-right: 18.5px;\n}\n\n.guttar-38px {\n  margin-left: -19px;\n  margin-right: -19px;\n}\n\n.guttar-38px>li,\n.guttar-38px>div {\n  padding-left: 19px;\n  padding-right: 19px;\n}\n\n.guttar-39px {\n  margin-left: -19.5px;\n  margin-right: -19.5px;\n}\n\n.guttar-39px>li,\n.guttar-39px>div {\n  padding-left: 19.5px;\n  padding-right: 19.5px;\n}\n\n.guttar-40px {\n  margin-left: -20px;\n  margin-right: -20px;\n}\n\n.guttar-40px>li,\n.guttar-40px>div {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.guttar-41px {\n  margin-left: -20.5px;\n  margin-right: -20.5px;\n}\n\n.guttar-41px>li,\n.guttar-41px>div {\n  padding-left: 20.5px;\n  padding-right: 20.5px;\n}\n\n.guttar-42px {\n  margin-left: -21px;\n  margin-right: -21px;\n}\n\n.guttar-42px>li,\n.guttar-42px>div {\n  padding-left: 21px;\n  padding-right: 21px;\n}\n\n.guttar-43px {\n  margin-left: -21.5px;\n  margin-right: -21.5px;\n}\n\n.guttar-43px>li,\n.guttar-43px>div {\n  padding-left: 21.5px;\n  padding-right: 21.5px;\n}\n\n.guttar-44px {\n  margin-left: -22px;\n  margin-right: -22px;\n}\n\n.guttar-44px>li,\n.guttar-44px>div {\n  padding-left: 22px;\n  padding-right: 22px;\n}\n\n.guttar-45px {\n  margin-left: -22.5px;\n  margin-right: -22.5px;\n}\n\n.guttar-45px>li,\n.guttar-45px>div {\n  padding-left: 22.5px;\n  padding-right: 22.5px;\n}\n\n.guttar-46px {\n  margin-left: -23px;\n  margin-right: -23px;\n}\n\n.guttar-46px>li,\n.guttar-46px>div {\n  padding-left: 23px;\n  padding-right: 23px;\n}\n\n.guttar-47px {\n  margin-left: -23.5px;\n  margin-right: -23.5px;\n}\n\n.guttar-47px>li,\n.guttar-47px>div {\n  padding-left: 23.5px;\n  padding-right: 23.5px;\n}\n\n.guttar-48px {\n  margin-left: -24px;\n  margin-right: -24px;\n}\n\n.guttar-48px>li,\n.guttar-48px>div {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.guttar-49px {\n  margin-left: -24.5px;\n  margin-right: -24.5px;\n}\n\n.guttar-49px>li,\n.guttar-49px>div {\n  padding-left: 24.5px;\n  padding-right: 24.5px;\n}\n\n.guttar-50px {\n  margin-left: -25px;\n  margin-right: -25px;\n}\n\n.guttar-50px>li,\n.guttar-50px>div {\n  padding-left: 25px;\n  padding-right: 25px;\n}\n\n/** Button **/\n.btn {\n  position: relative;\n  color: #fff;\n  padding: 10px 20px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1em;\n  border-radius: 4px;\n  transition: all .4s ease;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:active {\n  box-shadow: none;\n  outline: none;\n}\n\n.btn .ti,\n.btn [class*=fa-] {\n  margin-right: 8px;\n}\n\n.btn-icon {\n  letter-spacing: 0.01em;\n}\n\n.btn-sm {\n  padding: 10px 18px;\n  line-height: 19px;\n}\n\n.btn-xs {\n  padding: 5px 12px;\n  font-size: 11px;\n  line-height: 18px;\n  text-transform: none;\n  letter-spacing: 0.025em;\n}\n\n.btn-uline {\n  padding: 0;\n}\n\n.btn-uline:after {\n  position: absolute;\n  content: '';\n  height: 1px;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  transition: all .4s;\n}\n\n.btn-uline-light {\n  color: #91a5cb;\n}\n\n.btn-uline-light:after {\n  background: #91a5cb;\n}\n\n.btn-uline-light:hover,\n.btn-uline-light:focus,\n.btn-uline-light:active {\n  color: #6783b8;\n}\n\n.btn-uline-light:hover:after,\n.btn-uline-light:focus:after,\n.btn-uline-light:active:after {\n  background: #6783b8;\n}\n\n.btn-uline-warning {\n  color: #ffdc70;\n}\n\n.btn-uline-warning:after {\n  background: #ffdc70;\n}\n\n.btn-uline-warning:hover,\n.btn-uline-warning:focus,\n.btn-uline-warning:active {\n  color: #ffc100;\n}\n\n.btn-uline-warning:hover:after,\n.btn-uline-warning:focus:after,\n.btn-uline-warning:active:after {\n  background: #ffc100;\n}\n\n.btn-uline-primary {\n  color: #96abfa;\n}\n\n.btn-uline-primary:after {\n  background: #96abfa;\n}\n\n.btn-uline-primary:hover,\n.btn-uline-primary:focus,\n.btn-uline-primary:active {\n  color: #2b56f5;\n}\n\n.btn-uline-primary:hover:after,\n.btn-uline-primary:focus:after,\n.btn-uline-primary:active:after {\n  background: #2b56f5;\n}\n\n.btn-uline-info {\n  color: #f7fbff;\n}\n\n.btn-uline-info:after {\n  background: #f7fbff;\n}\n\n.btn-uline-info:hover,\n.btn-uline-info:focus,\n.btn-uline-info:active {\n  color: #87bfff;\n}\n\n.btn-uline-info:hover:after,\n.btn-uline-info:focus:after,\n.btn-uline-info:active:after {\n  background: #87bfff;\n}\n\n.btn-uline-success {\n  color: #43ffba;\n}\n\n.btn-uline-success:after {\n  background: #43ffba;\n}\n\n.btn-uline-success:hover,\n.btn-uline-success:focus,\n.btn-uline-success:active {\n  color: #00d285;\n}\n\n.btn-uline-success:hover:after,\n.btn-uline-success:focus:after,\n.btn-uline-success:active:after {\n  background: #00d285;\n}\n\n.btn-uline-danger {\n  color: #ff7070;\n}\n\n.btn-uline-danger:after {\n  background: #ff7070;\n}\n\n.btn-uline-danger:hover,\n.btn-uline-danger:focus,\n.btn-uline-danger:active {\n  color: #ff0000;\n}\n\n.btn-uline-danger:hover:after,\n.btn-uline-danger:focus:after,\n.btn-uline-danger:active:after {\n  background: #ff0000;\n}\n\n.btn-facebook {\n  background: #3b5998;\n  border-color: #3b5998;\n  box-shadow: 0px 2px 18px 2px rgba(59, 89, 152, 0.25);\n}\n\n.btn-facebook:hover,\n.btn-facebook:focus,\n.btn-facebook:active {\n  color: #fff;\n  background: #344e86;\n  border-color: #344e86;\n}\n\n.btn-google {\n  background: #d85040;\n  border-color: #d85040;\n  box-shadow: 0px 2px 18px 2px rgba(216, 80, 64, 0.25);\n}\n\n.btn-google:hover,\n.btn-google:focus,\n.btn-google:active {\n  color: #fff;\n  background: #d33d2b;\n  border-color: #d33d2b;\n}\n\n.btn-light {\n  background: #6783b8;\n  border-color: #6783b8;\n  box-shadow: 0px 2px 18px 2px rgba(103, 131, 184, 0.25);\n}\n\n.btn-light:hover,\n.btn-light:focus,\n.btn-light:active {\n  color: #fff;\n  background: #5675b0;\n  border-color: #5675b0;\n}\n\n.btn-warning {\n  background: #ffc100;\n  border-color: #ffc100;\n  box-shadow: 0px 2px 18px 2px rgba(255, 193, 0, 0.25);\n}\n\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active {\n  color: #fff;\n  background: #e6ae00;\n  border-color: #e6ae00;\n}\n\n.btn-primary {\n  background: #2b56f5;\n  border-color: #2b56f5;\n  box-shadow: 0px 2px 18px 2px rgba(43, 86, 245, 0.25);\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active {\n  color: #fff;\n  background: #1343f4;\n  border-color: #1343f4;\n}\n\n.btn-info {\n  background: #87bfff;\n  border-color: #87bfff;\n  box-shadow: 0px 2px 18px 2px rgba(135, 191, 255, 0.25);\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active {\n  color: #fff;\n  background: #6eb1ff;\n  border-color: #6eb1ff;\n}\n\n.btn-success {\n  background: #00d285;\n  border-color: #00d285;\n  box-shadow: 0px 2px 18px 2px rgba(0, 210, 133, 0.25);\n}\n\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active {\n  color: #fff;\n  background: #00b975;\n  border-color: #00b975;\n}\n\n.btn-danger {\n  background: #ff0000;\n  border-color: #ff0000;\n  box-shadow: 0px 2px 18px 2px rgba(255, 0, 0, 0.25);\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active {\n  color: #fff;\n  background: #e60000;\n  border-color: #e60000;\n}\n\n.btn-grp {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: -10px;\n  margin-bottom: -10px;\n}\n\n.btn-grp li {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.btn-grp .btn-uline {\n  position: relative;\n  top: -4px;\n}\n\n.note {\n  padding: 15px 15px 15px 45px;\n  border-radius: 4px;\n  position: relative;\n}\n\n.note-no-icon {\n  padding: 15px;\n}\n\n.note-no-icon.note-lg {\n  padding: 15px 25px;\n}\n\n.note [class*=fa] {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  font-size: 12px;\n  line-height: 20px;\n  width: 45px;\n  text-align: center;\n}\n\n.note p {\n  font-size: 12px !important;\n  line-height: 1.5em;\n}\n\n.note-md p {\n  font-size: 13px !important;\n}\n\n.note-plane {\n  padding: 0 0 0 20px;\n  background: transparent !important;\n}\n\n.note-plane [class*=fa] {\n  top: 0;\n  transform: translateY(0);\n  left: 0;\n  font-size: 12px;\n  line-height: 18px;\n  width: 20px;\n  text-align: left;\n}\n\n.note-info {\n  background: #edf5ff;\n}\n\n.note-info p {\n  color: #6783b8 !important;\n}\n\n.note-info [class*=fa] {\n  color: #87bfff;\n}\n\n.note-success {\n  background: rgba(0, 210, 133, 0.15);\n}\n\n.note-success p {\n  color: rgba(0, 210, 133, 0.9) !important;\n}\n\n.note-success [class*=fa] {\n  color: #00d285;\n}\n\n.note-danger {\n  background: rgba(255, 0, 0, 0.05);\n}\n\n.note-danger p {\n  color: rgba(255, 0, 0, 0.7) !important;\n}\n\n.note-danger [class*=fa] {\n  color: rgba(255, 0, 0, 0.7);\n}\n\n.alert-xs {\n  padding: 5px 12px;\n  font-size: 11px;\n  line-height: 18px;\n  text-transform: none;\n  letter-spacing: 0.025em;\n}\n\n.alert-success {\n  color: #fff;\n  background: #00d285;\n  border-color: #00d285;\n  box-shadow: 0px 2px 18px 2px rgba(0, 210, 133, 0.25);\n}\n\n.alert-error {\n  color: #fff;\n  background: #ff0000;\n  border-color: #ff0000;\n  box-shadow: 0px 2px 18px 2px rgba(255, 0, 0, 0.25);\n}\n\n.alert-box {\n  text-align: center;\n  border-radius: 4px;\n  padding: 15px;\n  display: block;\n  border: 1px solid;\n  margin-bottom: 30px;\n}\n\n.alert-primary {\n  background: #def8ff;\n  border-color: #bae2ed;\n}\n\n.alert-txt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 20px;\n  font-size: 12px;\n}\n\n.alert-txt .ti,\n.alert-txt .iconfont,\n.alert-txt [class*=fa-] {\n  margin-right: 10px;\n  line-height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  text-align: center;\n  background: #f2b2a7;\n  color: #af4038;\n  flex-shrink: 0;\n}\n\n@media (min-width: 768px) {\n  .alert-box {\n    padding: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .alert-txt {\n    padding-bottom: 0;\n    font-size: 14px;\n    justify-content: flex-start;\n  }\n}\n\n.color-light {\n  color: #6783b8;\n}\n\n.color-dark {\n  color: #304073;\n}\n\n.color-warning {\n  color: #ffc100;\n}\n\n.color-primary {\n  color: #2b56f5;\n}\n\n.color-info {\n  color: #87bfff;\n}\n\n.color-success {\n  color: #00d285;\n}\n\n.color-danger {\n  color: #ff0000;\n}\n\n/** Table **/\n.table tr {\n  background: rgba(220, 230, 245, 0.2);\n}\n\n.table tr:nth-child(even) {\n  background: rgba(220, 230, 245, 0.6);\n}\n\n.table tr:last-child td:first-child {\n  border-radius: 0 0 0 4px;\n}\n\n.table tr:last-child td:last-child {\n  border-radius: 0 0 4px 0;\n}\n\n.table td {\n  padding: 10px 20px;\n  border: none;\n  white-space: nowrap;\n  color: #304073;\n}\n\n.table td span {\n  color: #6783b8;\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1.1;\n  padding-top: 5px;\n}\n\n.table thead tr {\n  background: #d4e0f3;\n}\n\n.table thead th {\n  padding: 10px 20px;\n  border: none;\n  color: #6783b8;\n  white-space: nowrap;\n}\n\n.table thead th:first-child {\n  border-radius: 4px 0 0 0;\n}\n\n.table thead th:last-child {\n  border-radius: 0 4px 0 0;\n}\n\n/** Accordion @simple **/\n.accordion-simple {\n  padding-bottom: 25px;\n}\n\n.accordion-simple:last-child {\n  padding-bottom: 0;\n}\n\n.accordion-item {\n  padding-bottom: 5px;\n  border: none;\n}\n\n.accordion-item:last-child {\n  padding-bottom: 0;\n}\n\n.accordion-heading {\n  cursor: pointer;\n  color: #6783b8;\n  font-weight: 500;\n  transition: all .4s;\n  margin-bottom: 8px;\n  padding-left: 20px;\n  font-size: 1em;\n  position: relative;\n}\n\n.accordion-heading:before,\n.accordion-heading:after {\n  position: absolute;\n  content: '';\n}\n\n.accordion-heading:before {\n  left: 0;\n  top: 10px;\n  height: 1px;\n  width: 11px;\n  background: #6783b8;\n}\n\n.accordion-heading:after {\n  left: 5px;\n  top: 5px;\n  height: 11px;\n  width: 1px;\n  background: #6783b8;\n  transform: scaleX(1) scaleY(0);\n  transition: all .3s ease;\n}\n\n.accordion-heading.collapsed:after {\n  transform: scaleX(1) scaleY(1);\n}\n\n.accordion-heading:hover {\n  color: #304073;\n}\n\n.accordion-content {\n  padding: 0 0 15px 20px;\n}\n\n.or-saparator {\n  position: relative;\n  padding: 10px 0;\n}\n\n.or-saparator:before {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 1px;\n  margin-top: 1px;\n  width: 100%;\n  content: '';\n  background: rgba(40, 56, 76, 0.1);\n  z-index: 1;\n}\n\n.or-saparator span {\n  position: relative;\n  display: inline-block;\n  font-size: 0.81em;\n  padding: 0 8px;\n  background: #fff;\n  color: #6783b8;\n  z-index: 2;\n}\n\n.small-heading {\n  display: block;\n  font-size: .8em;\n  line-height: 1;\n  letter-spacing: 0.2em;\n  color: #304073;\n  margin-bottom: 20px;\n}\n\n.simple-link {\n  font-size: 13px;\n}\n\n.simple-link .ti {\n  font-size: 10px;\n  font-weight: bold;\n}\n\n/** Dropdown **/\n.dropdown-menu {\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08);\n  border: none;\n}\n\n/** Tooltip **/\n[data-toggle=\"tooltip\"] {\n  cursor: help;\n}\n\n.tooltip-inner {\n  background: #fff;\n  font-size: 10px;\n  color: #6783b8;\n  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.07);\n}\n\n.tooltip.bs-tooltip-right .arrow:before {\n  border-right-color: #fff !important;\n}\n\n.tooltip.bs-tooltip-left .arrow:before {\n  border-left-color: #fff !important;\n}\n\n.tooltip.bs-tooltip-bottom .arrow:before {\n  border-bottom-color: #fff !important;\n}\n\n.tooltip.bs-tooltip-top .arrow:before {\n  border-top-color: #fff !important;\n}\n\n.modal-content {\n  position: relative;\n  border-radius: 8px;\n  border: 2px solid #d3e0f3;\n  box-shadow: 0px 0px 50px 0px rgba(48, 64, 115, 0.1);\n}\n\n.modal-content .modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: inline-block;\n}\n\n.modal-content .modal-close .fa,\n.modal-content .modal-close .ti {\n  font-size: 20px;\n  height: 44px;\n  width: 44px;\n  line-height: 44px;\n  text-align: center;\n  background: #c1d1e8;\n  border-radius: 50%;\n  color: #304073;\n  text-shadow: none;\n  display: block;\n  transition: all .4s;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 100%;\n    min-width: 100%;\n  }\n}\n\n@media (min-width: 640px) {\n  .modal-dialog {\n    max-width: 630px;\n    min-width: 630px;\n  }\n}\n\n@media (min-width: 660px) {\n  .modal-content .modal-close {\n    top: -22px;\n    right: -22px;\n  }\n}\n\n/** Select **/\nselect:focus {\n  outline: none;\n  border: none;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n  line-height: 40px;\n  font-size: .9em;\n  padding-left: 15px;\n  padding-right: 44px;\n  color: #304073;\n}\n\n.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered {\n  padding-right: 20px;\n  padding-left: 44px;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background: #e3f0ff;\n  color: #304073;\n}\n\n.select2-container--default .select2-results__option[aria-selected=true] {\n  background: #e3f0ff;\n  color: #304073;\n}\n\n.select2-container--default .select2-results__option {\n  padding: 12px 20px;\n  border-bottom: 1px solid #edf5ff;\n}\n\n.select2-container--default .select2-results__option:last-child {\n  border-bottom: none;\n}\n\n.select2-container .select2-selection--single {\n  height: 44px;\n}\n\n.select2-container--default .select2-selection--single {\n  background: #fff;\n  color: #8599c6;\n  border: 2px solid #d3e0f3;\n  border-radius: 4px;\n  transition: all .4s;\n}\n\n.select2-container--default .select2-selection--single:focus {\n  outline: none;\n}\n\n.select2-container--open.select2-container--default .select2-selection--single {\n  border: 2px solid #a1cdff;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 44px;\n  width: 44px;\n  top: 0;\n  right: 0;\n  transition: all .5s ease;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 0;\n  width: 0;\n  content: '';\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #8599c7;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n  display: none;\n}\n\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow {\n  transform: rotate(-180deg);\n}\n\n.select2-container.select2-container--open {\n  width: auto !important;\n  max-width: 100% !important;\n}\n\n.select2-container.select2 {\n  width: 100% !important;\n}\n\n.auto-width .select2-container.select2 {\n  width: auto !important;\n}\n\n.select2-container--default .select2-results>.select2-results__options {\n  max-height: 400px;\n  overflow: scroll;\n  background: #fff;\n  border: 2px solid #a1cdff;\n}\n\n.select2-container--default .select2-dropdown--below .select2-results>.select2-results__options {\n  border-radius: 0 0 4px 4px;\n  border-top: none;\n}\n\n.select2-container--default .select2-dropdown--above .select2-results>.select2-results__options {\n  border-radius: 4px 4px 0 0;\n  border-bottom: none;\n}\n\n.select2-search--dropdown {\n  display: none;\n}\n\n.select2-dropdown {\n  border-radius: 0;\n  border: none;\n  background: transparent;\n  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.03);\n}\n\n.select2-results__option {\n  padding: 6px 20px;\n  transition: all .5s ease;\n}\n\n/** Topbar **/\n.topbar {\n  background: #fff;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 999;\n  min-width: 310px;\n  box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.02);\n}\n\n.topbar-md {\n  position: relative;\n  background: #fff;\n  z-index: 2;\n  text-align: center;\n}\n\n.topbar-action {\n  border-top: 1px solid rgba(234, 243, 252, 0.5);\n  box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.02);\n  transition: all .4s ease;\n}\n\n.topbar-action.active {\n  opacity: 1;\n  top: 64px;\n  visibility: visible;\n}\n\n.topbar-action-list {\n  display: inline-flex;\n  align-items: center;\n  margin: 0 -15px;\n  justify-content: center;\n}\n\n.topbar-action-list .topbar-action-item {\n  padding: 0 15px;\n}\n\n.topbar-action-item {\n  flex-shrink: 0;\n}\n\n.topbar-action-item>a {\n  padding: 15px 0;\n  display: inline-block;\n  color: #5e698c;\n}\n\n.topbar-action-item>a:hover {\n  color: #2b56f5;\n}\n\n.topbar-action-item .dropdown-menu {\n  min-width: auto;\n  margin: 0;\n  padding: 0;\n}\n\n.topbar-action-item .user-box {\n  padding: 10px 20px;\n}\n\n.topbar-action-link a {\n  font-size: 14px;\n  line-height: 30px;\n}\n\n.topbar-action-link .ti,\n.topbar-action-link .icofont,\n.topbar-action-link [class*=\"fa-\"] {\n  font-size: 18px;\n  margin-right: 10px;\n  line-height: 30px;\n}\n\n.topbar-action-language a {\n  color: #323d63;\n  font-weight: 500;\n}\n\n.topbar-action-language a:hover {\n  color: #2b56f5;\n}\n\n.topbar-action-language.show>a {\n  color: #2b56f5;\n}\n\n.topbar-action-language .ti,\n.topbar-action-language .icofont,\n.topbar-action-language [class*=\"fa-\"] {\n  font-size: 12px;\n  margin-left: 5px;\n  line-height: 30px;\n  font-weight: 400;\n}\n\n.topbar-action-language .dropdown-menu li {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.02);\n}\n\n.topbar-action-language .dropdown-menu li:last-child {\n  border-bottom: none;\n}\n\n.topbar-action-language .dropdown-menu li a {\n  display: block;\n  line-height: 18px;\n  padding: 7px 25px;\n  font-size: 14px;\n  letter-spacing: 0.1em;\n}\n\n.topbar-action-language.dropdown .dropdown-menu {\n  top: 100% !important;\n  left: 50% !important;\n  transform: translate(-50%, 0) !important;\n  margin-top: 11px;\n}\n\n.topbar-action-language.dropdown .dropdown-menu:before {\n  position: absolute;\n  top: -7px;\n  left: 50%;\n  margin-left: -7px;\n  height: 0;\n  width: 0;\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n}\n\n.topbar-action-language.dropup .dropdown-menu {\n  margin-bottom: -10px;\n}\n\n.topbar-action-user .dropdown-menu {\n  margin-top: 11px;\n  margin-right: -5px;\n}\n\n.topbar-action-user>a img {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n\n.topbar-action-user .user-box {\n  text-align: right;\n}\n\n.toggle-nav,\n.toggle-action {\n  width: 30px;\n  display: block;\n  transition: all .4s;\n}\n\n.toggle-nav {\n  left: 10px;\n}\n\n.toggle-nav .toggle-icon {\n  margin: -7.5px 0;\n}\n\n.toggle-nav.active .toggle-line {\n  width: 30px;\n}\n\n.toggle-nav.active .toggle-line:nth-last-of-type(1) {\n  transform-origin: bottom left;\n  transform: rotate(-45deg);\n}\n\n.toggle-nav.active .toggle-line:nth-last-of-type(2) {\n  opacity: 0;\n}\n\n.toggle-nav.active .toggle-line:nth-last-of-type(3) {\n  opacity: 0;\n}\n\n.toggle-nav.active .toggle-line:nth-last-of-type(4) {\n  transform-origin: top left;\n  transform: rotate(45deg);\n}\n\n.toggle-action {\n  right: 10px;\n}\n\n.toggle-action .toggle-icon {\n  margin: -4px 0;\n}\n\n.toggle-action.active .toggle-dot {\n  position: relative;\n}\n\n.toggle-action.active .toggle-dot:nth-last-of-type(1) {\n  transform: translate(-9px, -8px);\n}\n\n.toggle-action.active .toggle-dot:nth-last-of-type(3) {\n  transform: translate(9px, 8px);\n}\n\n.toggle-line {\n  display: block;\n  width: 28px;\n  height: 2px;\n  line-height: 0;\n  background: #6783b8;\n  margin: 5px 0;\n  transition: all .4s;\n}\n\n.toggle-line:nth-last-of-type(2) {\n  width: 70%;\n}\n\n.toggle-line:nth-last-of-type(3) {\n  width: 85%;\n}\n\n.toggle-dot {\n  display: block;\n  height: 6px;\n  width: 6px;\n  border-radius: 50%;\n  border: 1px solid #6783b8;\n  margin: 2px auto;\n  transition: all .4s;\n}\n\n.site-brand {\n  display: inline-block;\n}\n\n/** User **/\n.user-sidebar {\n  position: fixed;\n  width: 260px;\n  z-index: 99;\n  top: 0;\n  left: -260px;\n  height: 100%;\n  overflow: scroll;\n  padding: 60px 20px 20px 20px;\n  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);\n  transition: all .4s ease;\n  display: none;\n}\n\n.user-sidebar:before {\n  position: fixed;\n  top: 0;\n  left: -260px;\n  content: '';\n  height: 100%;\n  width: 260px;\n  background: #fff;\n  z-index: 1;\n  transition: all .4s ease;\n}\n\n.user-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  content: '';\n  height: 100%;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  transition: all .4s;\n  visibility: hidden;\n  opacity: 0;\n  z-index: -1;\n}\n\n.user-sidebar.active {\n  left: 0;\n}\n\n.user-sidebar.active:before {\n  left: 0;\n}\n\n.user-sidebar.active .user-sidebar-overlay {\n  opacity: 1;\n  visibility: visible;\n  transition-delay: 0.6s;\n}\n\n.user-sidebar-mobile {\n  display: block;\n}\n\n.user-sidebar>*:not(.user-sidebar-overlay) {\n  position: relative;\n  z-index: 2;\n}\n\n.user-sidebar-sap {\n  width: 30px;\n  height: 3px;\n  background: #d3e0f3;\n}\n\n.user-sidebar .topbar-action-link a {\n  font-size: 12px;\n}\n\n.user-sidebar-shown {\n  overflow: hidden;\n}\n\n.user-content {\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.user-panel {\n  padding: 20px;\n  background: #fff;\n  border-radius: 4px;\n  min-height: 100%;\n  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);\n}\n\n.user-panel-title {\n  color: #304073;\n}\n\n.user-panel-subtitle {\n  color: #6783b8;\n  font-weight: 400;\n  margin-bottom: 8px;\n}\n\n.user-panel-subtitle-red {\n  color: #fa5205;\n  font-weight: 400;\n  margin-bottom: 8px;\n}\n\n.user-panel p {\n  font-size: 14px;\n  color: #304073;\n}\n\n.user-panel-content img {\n  margin-bottom: 30px;\n}\n\n.user-panel-content .embed-responsive {\n  margin-bottom: 30px;\n}\n\n.user-kyc {\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);\n}\n\n.user-kyc p {\n  font-size: 14px;\n  color: #304073;\n}\n\n.user-dashboard {\n  padding-top: 80px;\n}\n\n.user-box {\n  text-align: center;\n}\n\n.user-dropdown {\n  min-width: 260px;\n  box-shadow: 0px 6px 22px 0px rgba(0, 0, 0, 0.05);\n}\n\n.user-dropdown-head {\n  background: #2b56f5;\n  padding: 20px 20px 12px 20px;\n  border-radius: 4px 4px 0 0;\n  position: relative;\n}\n\n.user-dropdown-head:after {\n  position: absolute;\n  right: 12px;\n  top: -7px;\n  height: 0;\n  width: 0;\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #2b56f5;\n}\n\n.user-dropdown-name {\n  color: #fff;\n  margin-bottom: 0;\n  line-height: 1;\n}\n\n.user-dropdown-name span {\n  font-size: 11px;\n  color: #87bfff;\n  line-height: 1;\n}\n\n.user-dropdown-email {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 12px;\n}\n\n.user-dropdown-balance {\n  padding: 14px 20px 17px 20px;\n}\n\n.user-dropdown-balance h6 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 0;\n  letter-spacing: 0.1em;\n  color: #6783b8;\n}\n\n.user-dropdown-balance h3 {\n  font-weight: 400;\n  margin-bottom: 0;\n  letter-spacing: -0.025em;\n  color: #304073;\n  line-height: 1;\n  margin-top: 3px;\n}\n\n.user-dropdown-balance ul {\n  margin: 0 -8px;\n}\n\n.user-dropdown-balance ul li {\n  color: #9eaecf;\n  display: inline-block;\n  padding: 0 8px;\n  font-size: 11px;\n  line-height: 18px;\n}\n\n.user-dropdown-btns {\n  padding: 5px 0;\n  border-top: 2px solid rgba(239, 246, 255, 0.5);\n  width: 100%;\n  justify-content: center;\n}\n\n.user-dropdown-links {\n  border-top: 2px solid rgba(239, 246, 255, 0.5);\n  margin-top: 0;\n  padding: 5px 0;\n}\n\n.user-dropdown-links li a {\n  color: #6783b8;\n  font-size: 15px;\n  padding: 4px 20px;\n  display: block;\n}\n\n.user-dropdown-links li a:hover {\n  color: #2b56f5;\n}\n\n.user-dropdown-links li a .ti {\n  width: 30px;\n  display: inline-block;\n}\n\n.user-dropdown-links li.active a {\n  color: #2b56f5;\n}\n\n.user-image img {\n  width: 70px;\n}\n\n.user-name {\n  color: #304073;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  white-space: nowrap;\n}\n\n.user-uid {\n  padding-bottom: 10px;\n  color: #6783b8;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 700;\n  padding-bottom: 10px;\n  text-transform: uppercase;\n}\n\n.user-uid span {\n  padding-top: 4px;\n  display: block;\n  color: #304073;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.user-icon-nav {\n  padding: 35px 0;\n}\n\n.user-icon-nav li {\n  padding: 5px 0;\n  border-top: 1px solid lightgray;\n  border-bottom: 1px solid lightgray;\n}\n\n.user-icon-nav li a {\n  color: #6783b8;\n  font-size: 15px;\n  line-height: 30px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n}\n\n.user-icon-nav li a .ti,\n.user-icon-nav li a .icofont,\n.user-icon-nav li a [class*=fa-] {\n  width: 35px;\n  font-size: 20px;\n  line-height: 30px;\n  color: #2b56f5;\n  text-shadow: 2.121px 2.121px 0.5px rgba(51, 204, 255, 0.2);\n}\n\n.user-icon-nav li.active a {\n  color: #2b56f5;\n  font-weight: 500;\n}\n\n.user-icon-nav li:hover a,\n.user-icon-nav li:focus a {\n  color: #2b56f5;\n}\n\n.user-nav {\n  padding: 30px 0;\n}\n\n.user-nav li {\n  padding: 5px 0;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 20px;\n  color: #6783b8;\n}\n\n.user-nav li a {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 20px;\n  color: #6783b8;\n  display: block;\n}\n\n.user-nav li a:hover {\n  color: #2b56f5;\n}\n\n.user-nav li span {\n  font-weight: 400;\n  text-transform: none;\n  display: block;\n  color: #304073;\n  font-size: 13px;\n}\n\n.user-nav li.active a {\n  color: #2b56f5;\n}\n\n.user-ath {\n  background: url(../images/bg-ath.png) no-repeat 50% 50%, #eaf3fc;\n  background-size: cover;\n}\n\n.user-ath-page {\n  display: flex;\n  min-height: 100vh;\n  align-items: center;\n  padding: 40px 0;\n}\n\n.user-ath-logo {\n  margin-bottom: 25px;\n}\n\n.user-ath-box {\n  position: relative;\n  padding: 45px 40px 40px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);\n}\n\n.user-ath-box:after {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 5px;\n  width: 100%;\n  content: '';\n  background: repeating-linear-gradient(90deg, #00bffa 0%, #00bffa 33.34%, #1b57fe 33.35%, #1b57fe 66.68%, #8255fd 66.69%, #8255fd 100%);\n  background-size: 50.5%;\n  overflow: hidden;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.user-ath-form .note {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 1024px) {\n  .user-dashboard {\n    padding-top: 90px;\n  }\n\n  .user-panel {\n    padding: 10px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .user-sidebar {\n    width: 220px;\n    position: relative;\n    flex-grow: 0;\n    flex-shrink: 0;\n    box-shadow: none;\n    height: auto;\n    left: 0;\n    padding: 0;\n    transition: unset;\n    display: block;\n    overflow: hidden;\n  }\n\n  .user-sidebar-overlay {\n    display: none;\n  }\n\n  .user-sidebar:before {\n    display: none;\n  }\n\n  .user-dashboard {\n    padding-top: 110px;\n  }\n\n  .user-content {\n    margin-left: 30px;\n  }\n}\n\n/** Notification List **/\n.notification-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 24px;\n  line-height: 1.4em;\n}\n\n.notification-list li:last-child {\n  padding-bottom: 0;\n}\n\n/** Cards **/\n.tile-item {\n  border-radius: 4px;\n  padding: 34px 20px 30px;\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 30px;\n  box-sizing: border-box;\n}\n\n.tile-item-lastprice {\n  height: 120px;\n  border-radius: 4px;\n  padding: 15px 15px 10px;\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n}\n\n.tile-item-lastprice-diff {\n  height: 120px;\n  border-radius: 4px;\n  padding: 15px 15px 10px;\n  text-align: center;\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n}\n\n.tile-bubbles {\n  position: absolute;\n  left: -25px;\n  top: -25px;\n  height: 120px;\n  width: 120px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.tile-bubbles:before,\n.tile-bubbles:after {\n  position: absolute;\n  content: '';\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.tile-bubbles:before {\n  height: 177px;\n  width: 177px;\n  top: 90px;\n  left: -7px;\n}\n\n.tile-bubbles:after {\n  height: 144px;\n  width: 144px;\n  top: 60px;\n  left: 60px;\n}\n\n.tile-primary {\n  background: #2b56f5;\n}\n\n.tile-light {\n  background: #eff6ff;\n  border: 2px solid #dce6f5;\n  padding: 32px 20px 28px;\n}\n\n.tile-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 4px;\n  letter-spacing: 0.1em;\n}\n\n.tile-light .tile-title {\n  color: #304073;\n}\n\n.tile-info {\n  font-weight: 400;\n  font-size: 19px;\n  margin-bottom: 0;\n  letter-spacing: -0.025em;\n}\n\n.tile-info-pricediff {\n  font-weight: 400;\n  font-size: 19px;\n  color: #ffa500;\n  margin-bottom: 0;\n  letter-spacing: -0.025em;\n}\n\n.tile-info-small {\n  margin: 0 -10px;\n  padding-top: 8px;\n  color: #6783b8;\n  font-size: 16px;\n}\n\n.tile-info-list {\n  margin: 0 -10px;\n  padding-top: 8px;\n  color: #6783b8;\n  font-size: 12px;\n}\n\n.tile-info-list li {\n  display: inline-block;\n  padding: 0 10px;\n  font-weight: 400;\n}\n\n.tile-info-list span {\n  color: #2b56f5;\n  display: block;\n  font-size: 19px;\n  line-height: 1;\n  padding-bottom: 12px;\n}\n\n.tile-list-inline {\n  margin: 0 -8px;\n}\n\n.tile-list-inline li {\n  color: #89c3ff;\n  display: inline-block;\n  padding: 0 8px;\n  font-size: 11px;\n  line-height: 18px;\n}\n\n@media (min-width: 576px) {\n  .tile-info {\n    font-size: 24px;\n  }\n\n  .tile-info-list span {\n    font-size: 24px;\n  }\n}\n\n.info-card {\n  margin-bottom: 30px;\n  border-radius: 4px;\n}\n\n.info-card h4 {\n  line-height: 28px;\n}\n\n.info-card p {\n  font-size: 14px;\n  color: #304073;\n  margin-bottom: 10px;\n}\n\n.info-card p:last-child {\n  margin-bottom: 0;\n}\n\n.info-card-bordered {\n  padding: 15px;\n  border: 2px solid #dce6f5;\n}\n\n.info-card-image img {\n  max-width: 100%;\n  width: 200px;\n}\n\n@media (min-width: 576px) {\n  .info-card-bordered {\n    padding: 25px;\n  }\n}\n\n.last-price {\n  border-radius: 6px;\n  background: #2b56f5;\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.bids-title {\n  color: #2b56f5;\n  font-weight: 400;\n  font-size: 19px;\n  letter-spacing: -0.025em;\n  margin-left: 5px;\n  margin-bottom: 6px;\n}\n\n.bids-area-1 {\n  height: 100px;\n  border: 2px;\n  padding: 0px;\n  overflow: auto;\n}\n\n.bids-area-2 {\n  height: 155px;\n  border: 2px;\n  padding: 0px;\n  overflow: auto;\n}\n\n.bids-area-n {\n  height: 195px;\n  border: 2px;\n  padding: 0px;\n  overflow: auto;\n}\n\n.token-card {\n  border-radius: 6px;\n  background: #6783b8;\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n.token-info {\n  width: 100%;\n  flex-grow: 1;\n  padding: 20px 10px 20px 50px;\n  position: relative;\n}\n\n.token-smartag {\n  position: absolute;\n  color: #fff;\n  background: #00d285;\n  line-height: 20px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 7px 30px;\n  min-width: 200px;\n  text-align: center;\n  top: 20px;\n  left: -60px;\n  transform: rotate(-45deg);\n}\n\n.token-bonus {\n  color: #fff;\n  margin-bottom: 14px;\n  padding-left: 25px;\n}\n\n.token-bonus span {\n  font-size: .5em;\n  color: #fff;\n}\n\n.token-timeline {\n  margin: 0 -16px;\n}\n\n.token-timeline li {\n  padding: 0 16px;\n  font-weight: 500;\n  display: inline-block;\n  color: #fff;\n}\n\n.token-timeline li span {\n  display: block;\n  font-weight: 600;\n  color: #87bfff;\n  line-height: 1;\n  font-size: 12px;\n  letter-spacing: 0.1em;\n}\n\n.token-countdown {\n  flex-grow: 1;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 25px;\n  text-align: center;\n}\n\n.token-countdown-title {\n  color: #87bfff;\n  font-weight: 600;\n  font-size: 12px;\n  letter-spacing: 0.1em;\n  margin-bottom: 6px;\n  display: block;\n}\n\n.token-countdown-clock {\n  display: flex;\n  color: #fff;\n}\n\n.token-countdown-clock .countdown-time {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.token-countdown-clock .countdown-text {\n  font-size: 12px;\n  line-height: 1;\n  display: block;\n}\n\n@media (min-width: 576px) {\n  .token-info {\n    padding: 20px 30px 20px 110px;\n  }\n\n  .token-bonus {\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .token-info {\n    width: 58%;\n    flex-grow: 0;\n  }\n}\n\n.progress-card {\n  border-radius: 4px;\n  padding: 20px 15px;\n  border: 2px solid #dce6f5;\n}\n\n.progress-card h4 {\n  margin-bottom: 16px;\n}\n\n.progress-info {\n  display: flex;\n  justify-content: space-between;\n}\n\n.progress-info li {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.progress-info li span {\n  color: #304073;\n  font-weight: 400;\n}\n\n.progress-bar {\n  display: block;\n  color: #6783b8;\n  background: #6a88f8;\n  overflow: visible;\n  height: 20px;\n  border-radius: 3px;\n  margin: 45px 0 15px;\n  position: relative;\n}\n\n.progress-hcap,\n.progress-scap,\n.progress-psale,\n.progress-percent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  border-radius: 3px;\n}\n\n.progress-hcap>div,\n.progress-scap>div,\n.progress-psale>div,\n.progress-percent>div {\n  position: absolute;\n  right: 0;\n  transform: translateX(50%);\n  width: 120px;\n  font-size: 10px;\n  line-height: 14px;\n  font-weight: 500;\n  padding: 30px 0 0 0;\n}\n\n.progress-hcap>div:after,\n.progress-scap>div:after,\n.progress-psale>div:after,\n.progress-percent>div:after {\n  position: absolute;\n  top: -30px;\n  left: 50%;\n  margin-left: -2px;\n  width: 4px;\n  height: 38px;\n  content: '';\n  background: #6a88f8;\n  font-weight: 400;\n}\n\n.progress-hcap>div span,\n.progress-scap>div span,\n.progress-psale>div span,\n.progress-percent>div span {\n  display: block;\n  color: #000;\n  position: absolute;\n  top: -45px;\n  left: 45%;\n  font-size: 14px;\n}\n\n.progress-hcap {\n  background: #aabbfb;\n}\n\n.progress-scap {\n  background: #8299d3;\n}\n\n.progress-psale {\n  background: #8299d3;\n}\n\n.progress-percent {\n  background: #2b56f5;\n}\n\n.progress-percent:after {\n  position: absolute;\n  content: '';\n  right: 0;\n  top: 50%;\n  height: 28px;\n  width: 28px;\n  border: 3px solid #2b56f5;\n  background: #fff;\n  border-radius: 50%;\n  transform: translate(50%, -50%);\n}\n\n@media (min-width: 768px) {\n  .progress-card {\n    padding: 20px;\n  }\n\n  .progress-info li {\n    font-size: 14px;\n  }\n\n  .progress-hcap>div,\n  .progress-scap>div,\n  .progress-psale>div,\n  .progress-percent>div {\n    font-size: 11px;\n  }\n}\n\n.status {\n  padding: 40px 20px;\n  border-radius: 4px;\n  text-align: center;\n  border: 1px solid #dce6f5;\n}\n\n.status-sm {\n  padding: 20px;\n}\n\n.status:not(:last-child) {\n  margin-bottom: 30px;\n}\n\n.status:not(:first-child) {\n  margin-top: 10px;\n}\n\n.status-icon {\n  position: relative;\n  height: 80px;\n  width: 80px;\n  background: #fff;\n  border-radius: 50%;\n  text-align: center;\n  margin: 0 auto 10px;\n  border: 2px solid #c8d8f0;\n}\n\n.status-icon>.ti {\n  color: #c9d9f1;\n  font-size: 30px;\n  line-height: 76px;\n}\n\n.status-icon-sm {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid #ffc7c7;\n}\n\n.status-icon-sm>.ti {\n  font-size: 12px;\n  line-height: 22px;\n  color: #ffc7c7;\n  display: block;\n}\n\n.status-text {\n  display: block;\n  font-size: 18px;\n  font-weight: 400;\n  color: #6783b8;\n  letter-spacing: -0.01em;\n  padding-bottom: 10px;\n}\n\n.status .btn {\n  margin-top: 10px;\n}\n\n.status-empty .status-icon {\n  background: #eff6ff;\n  border-color: #c8d8f0;\n}\n\n.status-empty .status-icon>.ti {\n  color: #c9d9f1;\n}\n\n.status-empty .status-icon-sm {\n  border-color: #ffc7c7;\n}\n\n.status-empty .status-icon-sm>.ti {\n  color: #ffc7c7;\n}\n\n.status-thank .status-icon,\n.status-verified .status-icon {\n  border-color: #06d388;\n}\n\n.status-thank .status-icon>.ti,\n.status-verified .status-icon>.ti {\n  color: #06d388;\n}\n\n.status-thank .status-icon-sm,\n.status-verified .status-icon-sm {\n  border-color: #06d388;\n}\n\n.status-thank .status-icon-sm>.ti,\n.status-verified .status-icon-sm>.ti {\n  color: #06d388;\n}\n\n.status-verified .status-text {\n  color: #06d388;\n}\n\n.status-process .status-icon {\n  border-color: #50b3ff;\n}\n\n.status-process .status-icon>.ti {\n  color: #50b3ff;\n}\n\n.status-process .status-icon-sm {\n  border-color: #50b3ff;\n}\n\n.status-process .status-icon-sm>.ti {\n  color: #50b3ff;\n}\n\n.status-canceled .status-icon {\n  border-color: #ffc7c7;\n}\n\n.status-canceled .status-icon>.ti {\n  color: #ffc7c7;\n}\n\n.status-canceled .status-icon-sm {\n  border-color: #ffc7c7;\n}\n\n.status-canceled .status-icon-sm>.ti {\n  color: #ffc7c7;\n}\n\n.status-canceled .status-text {\n  color: #ffc7c7;\n}\n\n.status-warnning .status-icon {\n  border-color: #ffd147;\n}\n\n.status-warnning .status-icon>.ti {\n  color: #ffd147;\n}\n\n.status-warnning .status-icon-sm {\n  border-color: #ffd147;\n}\n\n.status-warnning .status-icon-sm>.ti {\n  color: #ffd147;\n}\n\n@media (min-width: 576px) {\n  .status {\n    padding: 50px;\n  }\n\n  .status-sm {\n    padding: 20px;\n  }\n}\n\n/** Tabs **/\n.nav-tabs-line {\n  margin-bottom: 30px;\n  border-bottom: 2px solid #d3e0f3;\n}\n\n.nav-tabs-line .nav-item {\n  padding: 0 12px 0 0;\n  margin-bottom: 0;\n}\n\n.nav-tabs-line .nav-item:last-child {\n  padding: 0;\n}\n\n.nav-tabs-line .nav-link {\n  border: none;\n  padding: 6px 0;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: -0.03em;\n  color: rgba(103, 131, 184, 0.7);\n  position: relative;\n}\n\n.nav-tabs-line .nav-link:after {\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  content: '';\n  width: 0;\n  height: 2px;\n  background: #2b56f5;\n  transition: all .4s;\n}\n\n.nav-tabs-line .nav-link.active {\n  color: #304073;\n}\n\n.nav-tabs-line .nav-link.active:after {\n  width: 100%;\n}\n\n.nav-tabs-bordered {\n  display: block;\n  margin: 0 -7px;\n  border-bottom: 0;\n  display: flex;\n}\n\n.nav-tabs-bordered .nav-item {\n  margin-bottom: 0;\n  flex-grow: 1;\n  width: 33.33%;\n  padding: 0 7px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.nav-tabs-bordered .nav-link {\n  text-align: center;\n  display: block;\n  border: 2px solid #d3e0f3;\n  border-radius: 4px;\n  color: #d3e0f3;\n  padding: 12px 0 10px;\n  font-size: 11px;\n  height: 100%;\n}\n\n.nav-tabs-bordered .nav-link.active {\n  border: 2px solid #2b56f5;\n  color: #2b56f5;\n}\n\n.nav-tabs-icon {\n  position: relative;\n  width: 44px;\n  margin: 0 auto 5px;\n}\n\n.nav-tabs-icon img {\n  transition: all .4s;\n  width: 100%;\n}\n\n.nav-tabs-icon img:first-of-type {\n  opacity: 1;\n}\n\n.nav-tabs-icon img:last-of-type {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.active .nav-tabs-icon img:first-of-type {\n  opacity: 0;\n}\n\n.active .nav-tabs-icon img:last-of-type {\n  opacity: 1;\n}\n\n@media (min-width: 420px) {\n  .nav-tabs-line .nav-item {\n    padding: 0 30px 0 0;\n  }\n\n  .nav-tabs-line .nav-link {\n    font-size: 13px;\n    letter-spacing: 0em;\n  }\n}\n\n@media (min-width: 576px) {\n  .nav-tabs-bordered .nav-item {\n    padding: 0 15px;\n    margin-bottom: 25px;\n  }\n\n  .nav-tabs-bordered .nav-link {\n    font-size: 14px;\n  }\n\n  .nav-tabs-icon {\n    width: 64px;\n  }\n}\n\n@media (min-width: 768px) {\n  .nav-tabs-line .nav-item {\n    padding: 0 40px 0 0;\n  }\n\n  .nav-tabs-line .nav-link {\n    font-size: 14px;\n  }\n}\n\n/** Input Style **/\n.input-item {\n  padding-bottom: 16px;\n}\n\n.input-item-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #6783b8;\n  line-height: 1;\n}\n\n.input-bordered {\n  border-radius: 4px;\n  border: 2px solid #d3e0f3;\n  width: 100%;\n  padding: 10px 15px;\n  line-height: 20px;\n  font-size: 14px;\n  color: #6783b8;\n  transition: all .4s;\n}\n\n.input-bordered::-webkit-input-placeholder {\n  color: #6783b8;\n}\n\n.input-bordered::-moz-placeholder {\n  color: #6783b8;\n}\n\n.input-bordered:-ms-input-placeholder {\n  color: #6783b8;\n}\n\n.input-bordered:-moz-placeholder {\n  color: #6783b8;\n}\n\n.input-bordered:focus {\n  box-shadow: none;\n  outline: none;\n  border-color: #a1cdff;\n}\n\n.input-bordered-error {\n  border-color: rgba(255, 0, 0, 0.6);\n}\n\n.input-switch {\n  display: none;\n}\n\n.input-switch~label {\n  cursor: pointer;\n  height: 24px;\n  min-width: 50px;\n  border-radius: 12px;\n  margin-bottom: 0;\n  display: block;\n  position: relative;\n}\n\n.input-switch~label:before,\n.input-switch~label:after {\n  position: absolute;\n  content: '';\n  transition: all .4s;\n}\n\n.input-switch~label:before {\n  left: 0;\n  top: 0;\n  height: 24px;\n  width: 50px;\n  border-radius: 12px;\n  background: #d3e0f3;\n}\n\n.input-switch~label:after {\n  left: 3px;\n  top: 3px;\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.input-switch:checked~label:before {\n  background: #2b56f5;\n}\n\n.input-switch:checked~label:after {\n  left: calc(100% - 21px);\n}\n\n.input-checkbox {\n  display: none;\n}\n\n.input-checkbox+label {\n  font-size: 13px;\n  line-height: 20px;\n  margin-bottom: 0;\n  color: #6783b8;\n  padding-left: 40px;\n  position: relative;\n  cursor: pointer;\n  transition: all .4s;\n}\n\n.input-checkbox+label:before,\n.input-checkbox+label:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  border-radius: 2px;\n  transition: all .4s;\n}\n\n.input-checkbox+label:before {\n  content: '';\n  border: 2px solid #d3e0f3;\n}\n\n.input-checkbox+label:after {\n  line-height: 20px;\n  text-align: center;\n  font-family: themify;\n  content: '\\e64c';\n  font-size: 10px;\n  font-weight: 900;\n  color: #fff;\n  background: #2b56f5;\n  opacity: 0;\n}\n\n.input-checkbox:checked+label:after {\n  opacity: 1;\n}\n\n.input-note {\n  font-size: 12px;\n  color: #6783b8;\n  opacity: .7;\n}\n\n.simple-switch {\n  flex-shrink: 0;\n  height: 24px;\n  width: 50px;\n  border-radius: 12px;\n  display: inline-block;\n  background: #d3e0f3;\n  position: relative;\n}\n\n.simple-switch:after {\n  position: absolute;\n  content: '';\n  transition: all .4s;\n  left: 3px;\n  top: 3px;\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.simple-switch.active {\n  background: #2b56f5;\n}\n\n.simple-switch.active:after {\n  left: calc(100% - 21px);\n}\n\n/** DropZone **/\n.dz-clickable {\n  background: #f3f8ff;\n  border: 1px dashed #d3e0f3;\n  border-radius: 4px;\n  padding: 20px 0 30px;\n  text-align: center;\n}\n\n.dz-message span {\n  display: block;\n  color: rgba(103, 131, 184, 0.6);\n}\n\n.dz-message-text {\n  font-size: 13px;\n}\n\n.dz-message-or {\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n\n.dz-preview {\n  margin-top: 20px;\n  position: relative;\n}\n\n.dz-image img {\n  border-radius: 4px;\n  border: 1px solid #d3e0f3;\n}\n\n.dz-filename {\n  font-size: 13px;\n}\n\n.dz-progress {\n  opacity: 1;\n  z-index: 1000;\n  pointer-events: none;\n  position: absolute;\n  height: 10px;\n  top: 55px;\n  left: 50%;\n  width: 80px;\n  transform: translateX(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 5px;\n  overflow: hidden;\n  transition: all .4s;\n}\n\n.dz-complete .dz-progress {\n  opacity: 0;\n}\n\n.dz-upload {\n  background: #333;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  transition: all .3s ease-in-out;\n}\n\n.dz-error-message,\n.dz-success-message {\n  font-size: 13px;\n}\n\n.dz-error-mark,\n.dz-success-mark {\n  position: absolute;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n}\n\n.dz-error-mark svg,\n.dz-success-mark svg {\n  height: 40px !important;\n  width: 40px !important;\n}\n\n.dz-error-mark svg g,\n.dz-success-mark svg g {\n  stroke-opacity: .7;\n  stroke-width: 2;\n}\n\n.dz-error-message {\n  color: #ff0000;\n}\n\n.dz-error-mark g {\n  stroke: rgba(255, 0, 0, 0.7) !important;\n}\n\n.dz-error .dz-error-mark {\n  display: block;\n}\n\n.dz-success-message {\n  color: #00d285;\n}\n\n.dz-success-mark g {\n  stroke: rgba(0, 210, 133, 0.7) !important;\n}\n\n.dz-success .dz-success-mark {\n  display: block;\n}\n\n.upload-title {\n  color: #6783b8;\n  display: block;\n  font-size: 14px;\n  padding-bottom: 8px;\n  font-weight: 500;\n}\n\n/** KYC Upload **/\n.kyc-upload-title {\n  color: #304073;\n  margin-bottom: 12px;\n}\n\n.kyc-upload-list li {\n  color: #304073;\n  position: relative;\n  padding-left: 25px;\n}\n\n.kyc-upload-list li:before {\n  position: absolute;\n  left: 0;\n  top: 3px;\n  font-family: Font Awesome;\n  content: '\\f00c';\n  font-weight: 700;\n  color: #9eaecf;\n  margin-right: 4px;\n  font-size: 13px;\n}\n\n.kyc-popup {\n  padding: 30px;\n}\n\n@media (min-width: 575px) {\n  .kyc-upload-img {\n    padding: 0 30px 0;\n  }\n\n  .kyc-popup {\n    padding: 60px;\n  }\n}\n\n/** Form Style **/\n.from-step-item {\n  border-bottom: 1px solid #d3e0f3;\n}\n\n.from-step-item:last-child {\n  border-bottom: none;\n}\n\n.from-step-heading {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #d3e0f3;\n}\n\n.from-step-number {\n  font-size: 20px;\n  line-height: 24px;\n  padding: 10px 0;\n  flex-shrink: 0;\n  font-weight: 500;\n  color: #9eaecf;\n  width: 48px;\n  border-radius: 50%;\n  text-align: center;\n  border: 2px solid;\n  margin-right: 15px;\n}\n\n.from-step-head h4 {\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\n.from-step-head p {\n  color: #304073;\n  font-size: 13px;\n}\n\n.from-step-content {\n  padding: 20px;\n  flex-grow: 1;\n}\n\n@media (min-width: 575px) {\n  .from-step-heading {\n    padding: 30px;\n  }\n\n  .from-step-content {\n    padding: 30px;\n  }\n}\n\n/** Payment Box **/\n.payment-item {\n  text-align: center;\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.payment-item>span {\n  display: block;\n  font-size: 13px;\n  color: #9eaecf;\n  line-height: 1;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.payment-item label {\n  width: 100%;\n  border: 2px solid #d3e0f3;\n  border-radius: 4px;\n  background: #eff6ff;\n  padding: 12px 20px 12px;\n  cursor: pointer;\n  transition: all .4s;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.payment-item label span {\n  padding-left: 15px;\n}\n\n.payment-item label:after {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  height: 30px;\n  width: 30px;\n  line-height: 26px;\n  content: '\\f00c';\n  font-weight: 600;\n  font-size: 12px;\n  color: #fff;\n  font-family: Font Awesome;\n  border-radius: 50%;\n  background: #2b56f5;\n  border: 3px solid #fff;\n  transition: all .4s;\n  transform: scale(0);\n}\n\n.payment-item input[type=\"radio\"] {\n  display: none;\n}\n\n.payment-item input[type=\"radio\"]:checked~label {\n  border-color: #2b56f5;\n}\n\n.payment-item input[type=\"radio\"]:checked~label:after {\n  transform: scale(1);\n}\n\n.payment-icon {\n  margin-bottom: 3px;\n}\n\n.payment-icon img {\n  width: 30px;\n  border-radius: 50%;\n}\n\n.payment-icon [class*=fa-] {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  line-height: 30px;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n}\n\n.payment-icon-eth img,\n.payment-icon-eth [class*=fa-] {\n  background: #6d75b7;\n}\n\n.payment-icon-ltc img,\n.payment-icon-ltc [class*=fa-] {\n  background: #bcbcbc;\n}\n\n.payment-icon-btc img,\n.payment-icon-btc [class*=fa-] {\n  background: #fdb722;\n}\n\n.payment-icon-usd img,\n.payment-icon-usd [class*=fa-] {\n  background: #229efd;\n}\n\n.payment-cur {\n  font-size: 16px;\n  color: #304073;\n}\n\n.payment-cal-cur {\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #6783b8;\n  display: inline-block;\n  padding: 8.5px 12px;\n}\n\n.payment-cal-cur:after {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  height: 24px;\n  width: 1px;\n  content: '';\n  transform: translateY(-50%);\n  background: #dce6f5;\n}\n\n.payment-calculator {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  margin: -16px 0;\n}\n\n.payment-calculator>div {\n  padding: 16px 0;\n  width: 100%;\n}\n\n.payment-calculator .ti {\n  position: absolute;\n  bottom: 50%;\n  color: #304073;\n  left: 50%;\n  transform: translate(-50%, 50%);\n  margin-bottom: -4px;\n}\n\n.payment-calculator label {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.payment-calculator-note {\n  font-size: 12px;\n}\n\n.payment-calculator-note [class*=fa-] {\n  color: #7c98ff;\n  margin-right: 5px;\n  display: inline-block;\n}\n\n.payment-input {\n  position: relative;\n}\n\n.payment-bonus-title {\n  font-weight: 500;\n  font-size: 14px;\n  color: #6783b8;\n  margin-bottom: 2px;\n}\n\n.payment-bonus-amount {\n  display: block;\n  color: #304073;\n  font-size: 18px;\n}\n\n.payment-bonus-amount span {\n  color: #9eaecf;\n  font-size: 12px;\n}\n\n.payment-bonus-time {\n  font-size: 12px;\n  color: #6783b8;\n  display: block;\n  line-height: 1;\n}\n\n.payment-summary {\n  border-radius: 4px;\n  border: 1px solid #dce6f5;\n  padding: 20px 18px 0;\n  margin-bottom: 30px;\n}\n\n.payment-summary-item {\n  padding-bottom: 10px;\n}\n\n.payment-summary-title {\n  color: #2b56f5;\n  font-size: 14px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n\n.payment-summary-info span:first-child:not(.payment-summary-amount) {\n  color: #6783b8;\n  font-size: 14px;\n  font-weight: 400;\n  position: relative;\n  top: -2px;\n}\n\n.payment-summary-info span:last-child {\n  font-size: 14px;\n  color: #6783b8;\n  font-weight: 500;\n}\n\n.payment-summary-amount {\n  font-size: 20px;\n  font-weight: 500;\n  color: #304073;\n}\n\n@media (min-width: 576px) {\n  .payment-calculator {\n    margin: 0 -24px;\n  }\n\n  .payment-calculator>div {\n    padding: 0 24px;\n    width: 50%;\n  }\n\n  .payment-calculator .ti {\n    position: absolute;\n    bottom: 8px;\n    left: 50%;\n    transform: rotate(-90deg) translate(50%, -50%);\n    margin-bottom: 0;\n  }\n\n  .payment-item {\n    margin-bottom: 30px;\n  }\n\n  .payment-item label {\n    padding: 20px 20px 10px;\n    display: block;\n  }\n\n  .payment-item label span {\n    padding-left: 0;\n  }\n\n  .payment-item>span {\n    position: static;\n    margin-top: 2px;\n    transform: translateY(0);\n  }\n\n  .payment-icon img {\n    width: 50px;\n  }\n\n  .payment-icon [class*=fa-] {\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n    font-size: 20px;\n  }\n}\n\n@media (min-width: 419px) and (max-width: 575px) {\n  .payment-list .col-sm-6 {\n    width: 50%;\n  }\n\n  .payment-item>span {\n    position: static;\n    margin-top: 2px;\n    transform: translateY(0);\n  }\n}\n\n/** Data Table **/\ntable.dataTable {\n  width: 100%;\n  overflow-x: scroll;\n}\n\n.dataTables_filter label {\n  margin-bottom: 0;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: center;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label {\n  width: 100%;\n  position: relative;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label:before {\n  position: absolute;\n  height: 30px;\n  width: 30px;\n  text-align: center;\n  line-height: 40px;\n  font-family: themify;\n  content: '\\e610';\n  color: #abbbd9;\n  font-size: 15px;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input {\n  width: 100%;\n  padding: 10px 30px;\n  line-height: 20px;\n  font-size: 13px;\n  border: none;\n  background: transparent;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input:focus {\n  border: none;\n  background: transparent;\n  outline: none;\n  box-shadow: none;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input:-moz-placeholder {\n  opacity: 1;\n  color: #abbbd9;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {\n  opacity: 1;\n  color: #abbbd9;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input::-webkit-input-placeholder {\n  opacity: 1;\n  color: #abbbd9;\n}\n\ndiv.dataTables_wrapper div.dataTables_length {\n  text-align: center;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n  color: #8599c7;\n}\n\ndiv.dataTables_wrapper div.dataTables_length select {\n  margin-left: 10px;\n}\n\ndiv.dataTables_wrapper div.dataTables_info {\n  color: #23406c;\n  padding: 30px 0 0;\n  text-align: center;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n  padding: 20px 0 0;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  justify-content: center;\n}\n\ndiv.dataTables_wrapper>.row>.col-12 {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.clear-table {\n  padding-top: 20px;\n}\n\n@media (min-width: 576px) {\n  div.dataTables_wrapper div.dataTables_filter {\n    text-align: left;\n  }\n\n  div.dataTables_wrapper div.dataTables_filter input {\n    text-align: left;\n  }\n\n  div.dataTables_wrapper div.dataTables_length {\n    text-align: right;\n  }\n\n  div.dataTables_wrapper div.dataTables_info {\n    text-align: right;\n  }\n\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: flex-start;\n  }\n\n  div.dataTables_wrapper>.row>.col-12 {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n.form-control {\n  width: 100%;\n  border: none;\n}\n\n.page-link {\n  padding: 10px 12px;\n  margin-left: 0;\n  margin: 0 4px;\n  text-align: center;\n  line-height: 20px;\n  min-width: 40px;\n  color: #abbbd9;\n  background: #eff6ff;\n  border: none;\n  border-radius: 4px;\n}\n\n.page-link:focus {\n  box-shadow: none;\n}\n\n.page-link:hover {\n  color: #6783b8;\n  background: #cad2f1;\n}\n\n.previous .page-link,\n.next .page-link {\n  background: #eff6ff;\n}\n\n.disabled.previous .page-link,\n.disabled.next .page-link {\n  display: none;\n}\n\n.page-item.active .page-link {\n  color: #6783b8;\n  background: #cad2f1;\n}\n\n.data-filter {\n  display: none;\n}\n\n.data-filter+label {\n  font-size: 13px;\n  line-height: 18px;\n  margin-bottom: 0;\n  color: #6783b8;\n  padding-left: 25px;\n  position: relative;\n  cursor: pointer;\n  transition: all .4s;\n  opacity: .7;\n}\n\n.data-filter+label:before,\n.data-filter+label:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  border-radius: 2px;\n}\n\n.data-filter+label:before {\n  content: '';\n  border: 2px solid #6783b8;\n}\n\n.data-filter+label:after {\n  line-height: 18px;\n  text-align: center;\n  font-family: themify;\n  content: '\\e64c';\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  background: #2b56f5;\n  opacity: 0;\n}\n\n.data-filter:checked+label {\n  opacity: 1;\n}\n\n.data-filter:checked+label:after {\n  opacity: 1;\n}\n\n.data-table {\n  border-spacing: 0 5px !important;\n}\n\n.data-table-filter a {\n  color: #6783b8;\n  position: relative;\n  top: 5px;\n}\n\n.data-table-filter a:hover {\n  color: #2b56f5;\n}\n\n.data-table-filter .dropdown-menu {\n  min-width: auto;\n}\n\n.data-table-filter .dropdown-menu li {\n  padding: 5px 20px;\n}\n\n.data-table thead th {\n  line-height: 18px;\n  font-weight: 600;\n  font-size: 12px;\n  color: #6783b8;\n  padding: 0 0 6px;\n  padding-right: 10px;\n}\n\n.data-table thead th:before,\n.data-table thead th:after {\n  display: none !important;\n}\n\n.data-table thead th:first-child {\n  padding-left: 20px;\n}\n\n.data-table thead th:focus,\n.data-table thead th:active {\n  box-shadow: none;\n  outline: none;\n}\n\n.data-table thead th span {\n  position: relative;\n  display: inline-block;\n}\n\n.data-table thead th span:before,\n.data-table thead th span:after {\n  position: absolute;\n  top: 1px;\n  opacity: 0.3;\n}\n\n.data-table thead th span:before {\n  content: '\\2191';\n  right: -20px;\n}\n\n.data-table thead th span:after {\n  content: '\\2193';\n  right: -13px;\n}\n\n.data-table thead th.sorting_disabled span:before,\n.data-table thead th.sorting_disabled span:after {\n  display: none;\n}\n\n.data-table thead th.sorting_asc span:before {\n  opacity: 1;\n}\n\n.data-table thead th.sorting_desc span:after {\n  opacity: 1;\n}\n\n.data-table tbody tr:hover td {\n  background: #d5e7ff;\n}\n\n.data-table tbody tr.odd td {\n  background: #eaf3ff;\n}\n\n.data-table tbody tr.even td {\n  background: #f4f9ff;\n}\n\n.data-table tbody td {\n  color: #6783b8;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 400;\n  line-height: 24px;\n  padding: 10px 0;\n  position: relative;\n  transition: all .4s;\n}\n\n.data-table tbody td div>span,\n.data-table tbody td>span {\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  margin-bottom: -5px;\n  color: #304073;\n}\n\n.data-table tbody td:last-child {\n  border-radius: 0 3px 3px 0;\n}\n\n.data-table tbody td:first-child {\n  padding-left: 12px;\n  border-radius: 3px 0 0 3px;\n}\n\n@media (min-width: 576px) {\n  .data-table tbody td {\n    font-size: 12px;\n    padding: 18px 0;\n  }\n\n  .data-table tbody td div>span,\n  .data-table tbody td>span {\n    font-size: 14px;\n  }\n\n  .data-table tbody td:first-child {\n    padding-left: 20px;\n  }\n}\n\n/** Transaction **/\nth.tranx-type span {\n  padding: 0;\n}\n\n.tranx-type span {\n  display: inline-block;\n  border-radius: 2px;\n  font-size: 12px;\n  line-height: 22px;\n  padding: 0 10px;\n}\n\n.tranx-type-purchase {\n  background: #9fffdc;\n  border: 1px solid #00d285;\n}\n\n.tranx-type-bonus {\n  background: #d4e8ff;\n  border: 1px solid #87bfff;\n}\n\n.tranx-type-withdraw {\n  background: #fff3cc;\n  border: 1px solid #ffc100;\n}\n\n.tranx-status {\n  width: 20px;\n}\n\n.tranx-status .ti {\n  height: 24px;\n  width: 24px;\n  line-height: 22px;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 12px;\n  border: 1px solid;\n  display: inline-block;\n  background: #fff;\n}\n\n.tranx-status-approved .ti {\n  color: #00d285;\n}\n\n.tranx-status-pending .ti {\n  color: #ffc100;\n}\n\n.tranx-status-cancled .ti {\n  color: #ff0000;\n}\n\n.tranx-amount,\n.tranx-from {\n  display: none;\n}\n\n.tranx-action {\n  width: 30px;\n}\n\n.tranx-action a {\n  color: #6783b8;\n  height: 30px;\n  width: 30px;\n  line-height: 34px;\n  text-align: center;\n  display: inline-block;\n  border-radius: 50%;\n}\n\n.tranx-action a:hover,\n.tranx-action a:focus {\n  color: #2b56f5;\n  background: #d4e6f9;\n}\n\n.tranx-popup {\n  padding: 25px;\n}\n\n.tranx-popup h5 {\n  color: #304073;\n  font-weight: 500;\n  margin-bottom: 13px;\n}\n\n.tranx-popup p {\n  font-size: 13px;\n  color: #6783b8;\n}\n\n.tranx-popup p strong {\n  font-weight: 500;\n  color: #4b69a1;\n}\n\n.tranx-info-list {\n  padding: 5px 0 15px;\n}\n\n.tranx-info-list li {\n  display: inline-block;\n  width: 48%;\n  font-size: 12px;\n  font-weight: 500;\n  color: #304073;\n}\n\n.tranx-info-list li span {\n  color: #6783b8;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.tranx-info-qr span {\n  display: block;\n  padding-bottom: 6px;\n  padding-bottom: 12px;\n  font-size: 13px;\n  color: #6783b8;\n}\n\n.tranx-info-qrimg {\n  width: 120px;\n}\n\n.tranx-payment-details.active {\n  display: block !important;\n}\n\n.tranx-payment-details h6 {\n  font-size: 13px;\n  color: #304073;\n  margin-bottom: 12px;\n}\n\n.tranx-payment-info {\n  position: relative;\n}\n\n.tranx-payment-info>[class*=fa] {\n  position: absolute;\n  top: 0;\n  left: 22px;\n  line-height: 20px;\n  padding: 15px 0;\n  font-size: 14px;\n  text-align: center;\n  color: #6783b8;\n}\n\n.tranx-payment-address {\n  border: none;\n  color: #6783b8;\n  line-height: 20px;\n  padding: 15px 40px;\n  border-radius: 4px;\n  border: 1px solid rgba(211, 224, 243, 0.5);\n  width: 100%;\n  background: #fff;\n}\n\n.tranx-payment-address:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.tranx-payment-copy {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  height: 40px;\n  width: 40px;\n  line-height: 20px;\n  padding: 10px 0;\n  text-align: center;\n  color: #6783b8;\n  background: #e9eff9;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  transition: all .4s;\n  /*-- @updated on v1.0.1 --*/\n}\n\n.tranx-payment-copy:focus,\n.tranx-payment-copy:hover {\n  color: #fff;\n  background: #2b56f5;\n  box-shadow: none;\n  outline: none;\n}\n\n.tranx-copy-feedback {\n  display: none;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  line-height: 20px;\n  padding: 15px 0;\n  font-weight: 500;\n  font-size: 12px;\n  letter-spacing: .05em;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 4px;\n  border: 1px solid rgba(211, 224, 243, 0.5);\n  color: #2b56f5;\n}\n\n.tranx-purchase-details.active {\n  display: block !important;\n}\n\n.tranx-purchase-details h6 {\n  color: #6783b8;\n  font-size: 12px;\n  letter-spacing: .2em;\n  margin-bottom: 14px;\n}\n\n.tranx-purchase-details h6 em {\n  padding: 0 7px;\n}\n\n.tranx-purchase-details h6 span {\n  font-weight: 400;\n  text-transform: none;\n  color: #6783b8;\n  letter-spacing: 0.02em;\n}\n\n.tranx-purchase-info {\n  border-radius: 6px;\n  margin-bottom: 27px;\n  border: 1px solid rgba(211, 224, 243, 0.5);\n}\n\n.tranx-purchase-info li {\n  display: block;\n}\n\n.tranx-purchase-info li:last-child .tranx-purchase-des {\n  border-bottom: none;\n}\n\n.tranx-purchase-head {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6783b8;\n  line-height: 20px;\n  padding: 14px 20px;\n  width: 100%;\n}\n\n.tranx-purchase-des {\n  font-size: 14px;\n  color: #304073;\n  line-height: 20px;\n  padding: 14px 20px;\n  flex-grow: 1;\n  border-top: 1px solid rgba(211, 224, 243, 0.5);\n  border-bottom: 1px solid rgba(211, 224, 243, 0.5);\n  display: flex;\n  justify-content: space-between;\n}\n\n.tranx-purchase-des span:last-child {\n  font-size: 12px;\n  color: #6783b8;\n}\n\n@media (min-width: 576px) {\n  .tranx-popup {\n    padding: 45px;\n  }\n\n  .tranx-amount,\n  .tranx-from {\n    display: table-cell;\n  }\n\n  .tranx-status {\n    width: 35px;\n  }\n\n  .tranx-status .ti {\n    height: 30px;\n    width: 30px;\n    line-height: 28px;\n    font-size: 14px;\n  }\n\n  .tranx-purchase-info li {\n    display: flex;\n  }\n\n  .tranx-purchase-head {\n    width: 185px;\n  }\n\n  .tranx-purchase-des {\n    border-top: none;\n    border-left: 1px solid rgba(211, 224, 243, 0.5);\n  }\n}\n\n/** Activities **/\n.activity-time {\n  min-width: 90px;\n}\n\n.activity-device {\n  display: none;\n}\n\n.activity-ip {\n  padding-right: 15px !important;\n}\n\n@media (min-width: 576px) {\n  .activity-time {\n    min-width: 120px;\n  }\n\n  .activity-device {\n    display: block;\n  }\n}\n\n.refferal-info {\n  position: relative;\n}\n\n.refferal-info>[class*=fa] {\n  position: absolute;\n  top: 0;\n  left: 18px;\n  line-height: 20px;\n  padding: 15px 0;\n  font-size: 14px;\n  text-align: center;\n  color: #6783b8;\n}\n\n.refferal-address {\n  border: none;\n  color: #6783b8;\n  line-height: 20px;\n  padding: 15px 40px;\n  border-radius: 4px;\n  border: 1px solid rgba(211, 224, 243, 0.5);\n  width: 100%;\n  background: #fff;\n}\n\n.refferal-address:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.refferal-copy {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  height: 40px;\n  width: 40px;\n  line-height: 20px;\n  padding: 10px 0;\n  text-align: center;\n  color: #6783b8;\n  background: #e9eff9;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  transition: all .4s;\n  /*-- @updated on v1.0.1 --*/\n}\n\n.refferal-copy:focus,\n.refferal-copy:hover {\n  color: #fff;\n  background: #2b56f5;\n  box-shadow: none;\n  outline: none;\n}\n\n.refferal-copy-feedback {\n  display: none;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  line-height: 20px;\n  padding: 15px 0;\n  font-weight: 500;\n  font-size: 12px;\n  letter-spacing: .05em;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 4px;\n  border: 1px solid rgba(211, 224, 243, 0.5);\n  color: #2b56f5;\n}\n\n.refferal-statistics {\n  border-radius: 4px;\n  border: 1px solid #dce6f5;\n  padding: 20px 18px 0;\n  margin-bottom: 30px;\n}\n\n.refferal-statistics-item {\n  padding-bottom: 10px;\n}\n\n.refferal-statistics-item h6 {\n  color: #2b56f5;\n  font-size: 14px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n\n.refferal-statistics-item span {\n  font-size: 20px;\n  font-weight: 500;\n  color: #304073;\n}\n\n.refferal-tokens,\n.refferal-channel {\n  display: none;\n}\n\n@media (min-width: 576px) {\n\n  .refferal-tokens,\n  .refferal-channel {\n    display: block;\n  }\n}\n\n.share-links {\n  margin: 0 -10px;\n}\n\n.share-links li {\n  display: inline-block;\n  margin: 10px 10px;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.share-links li a {\n  font-size: 17px;\n  line-height: 24px;\n  display: inline-block;\n  color: #6783b8;\n}\n\n.share-links li a:hover {\n  color: #2b56f5;\n}\n\n/** Author Info **/\n.ath-trigger {\n  display: flex;\n  align-items: center;\n  color: #6783b8;\n  line-height: 1.4em;\n}\n\n.ath-trigger:hover,\n.ath-trigger:active,\n.ath-trigger:focus,\n.ath-trigger.active {\n  color: #6783b8;\n}\n\n.ath-trigger span {\n  margin-right: 16px;\n}\n\n.ath-content {\n  display: none;\n}\n\n.ath-content h5 {\n  color: #6783b8;\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.ath-content-sublist {\n  padding: 0 0 20px 5px;\n}\n\n.ath-content-sublist li {\n  color: #6783b8;\n  font-size: 12px;\n  padding-bottom: 4px;\n}\n\n.ath-content-sublist li:before {\n  content: '-';\n  margin-right: 5px;\n}\n\n.ath-content-sublist li:last-child {\n  padding-bottom: 0;\n}\n\n.ath-content-qrimg {\n  width: 120px;\n  margin-bottom: 5px;\n}\n\n/** Datepicker **/\n.datepicker-dropdown.datepicker-orient-bottom:before {\n  bottom: -8px;\n  border-top: 6px solid #a6cffd;\n}\n\n.datepicker-dropdown.datepicker-orient-top:before {\n  top: -8px;\n  border-bottom: 6px solid #a6cffd;\n}\n\n.datepicker.dropdown-menu {\n  border: none;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  border: 2px solid #a6cffd;\n}\n\n.datepicker.dropdown-menu td {\n  padding: 7px 8px;\n  min-width: 35px;\n}\n\n.datepicker table thead tr th {\n  transition: all .4s;\n  color: #3c3c3c;\n}\n\n.datepicker table thead tr th:hover {\n  background: #eaf3fc !important;\n}\n\n.datepicker table tr th {\n  transition: all .4s;\n}\n\n.datepicker table tr td {\n  transition: all .4s;\n  color: #8599c6;\n}\n\n.datepicker table tr td.day:hover {\n  background: #eaf3fc;\n}\n\n.datepicker table tr td.old,\n.datepicker table tr td.new {\n  color: rgba(133, 153, 198, 0.4);\n}\n\n.datepicker table tr td.today {\n  background: #46bdf4;\n  color: #fff;\n}\n\n.datepicker table tr td.today:hover:hover {\n  color: #fff;\n  background: #2b56f5;\n}\n\n.datepicker table tr td.active.active {\n  background: #2b56f5;\n  color: #fff;\n}\n\n.datepicker table tr td.active.active:hover:hover {\n  color: #fff;\n  background: #2b56f5;\n}\n\n.datepicker table tr td span {\n  transition: all .4s;\n}\n\n.datepicker table tr td span:hover {\n  background: #eaf3fc;\n}\n\n.datepicker table tr td span.active.active {\n  background: #2b56f5;\n  color: #fff;\n}\n\n.datepicker table tr td span.active.active:hover:hover {\n  color: #fff;\n  background: #2b56f5;\n}\n\n.footer-bar {\n  font-size: 13px;\n  padding: 20px 0;\n  color: #6783b8;\n}\n\n.footer-bar a {\n  color: #6783b8;\n}\n\n.footer-bar a:hover,\n.footer-bar a:focus {\n  color: #2b56f5;\n}\n\n.footer-copyright {\n  display: block;\n  padding: 15px 0 0;\n}\n\n.footer-links {\n  padding: 15px 0;\n  margin: 0 -5px;\n}\n\n.footer-links li {\n  padding: 0 5px;\n  display: inline-block;\n  position: relative;\n}\n\n.footer-links li:after {\n  position: absolute;\n  right: -3px;\n  top: 0;\n  content: '|';\n  color: #6783b8;\n}\n\n.footer-links li:last-child:after {\n  content: '';\n}\n\n@media (min-width: 768px) {\n  .footer-bar {\n    padding: 40px 0 20px;\n  }\n\n  .footer-copyright {\n    padding: 15px 0;\n  }\n}\n\n/** END */\n.container {\n  white-space: pre-line;\n}\n\n.language-Type {\n  margin: 0 1px 0 10px;\n  text-align: left;\n  align-items: left;\n}\n\n.payment-Type {\n  margin: 0 1px 0 10px;\n}\n\n.partialexecution-Flag {\n  margin: 0 1px 0 10px;\n}\n\n.orderOption-Type {\n  margin: 0 1px 0 10px;\n}\n\n.bids-list-box {\n  border-radius: 4px;\n  padding: 10px 5px;\n  border: 2px solid #dce6f5;\n}\n\n.table th {\n  background: #fff;\n  padding: 8px 10px;\n  border-bottom: 1px solid #1a1a1a;\n  font-weight: bold;\n  text-align: left;\n}\n\n.table th.up {\n  background-image: url(\"../images/up_arrow.png\");\n}\n\n.table th.down {\n  background-image: url(\"../images/down_arrow.png\");\n}\n\n.table th.default {\n  background-image: url(\"../images/default.png\");\n}\n\nth.up,\nth.default,\nth.down {\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: center right;\n}\n\n.td-wrap-text {\n  word-break: break-all;\n}\n\n.tr-type1 {\n  border: 1px solid grey;\n}\n\n.td-type1-col1 {\n  padding: 10px 10px;\n  width: 35%;\n  background: lightgrey;\n  color: black;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 2;\n  padding-top: 5px;\n  text-align: left;\n}\n\n.td-type1-col2 {\n  padding: 10px 10px;\n  width: 65%;\n  background: white;\n  color: black;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 2;\n  padding-top: 5px;\n  text-align: left;\n}\n\n.td-type2-col1 {\n  padding: 10px 10px;\n  width: 40%;\n  color: black;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 2;\n  padding-top: 5px;\n  text-align: left;\n  word-break: break-all;\n}\n\n.td-type2-col2 {\n  padding: 10px 10px;\n  width: 60%;\n  color: black;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 2;\n  padding-top: 5px;\n  text-align: left;\n  word-break: normal;\n}\n\n.SubMenu {\n  margin-left: 15px\n}\n\n.SubMenuText {\n  margin-left: 0px\n}\n\n.TopMenuIcon {\n  margin-left: 25px;\n  align-items: right;\n  text-align: right;\n}\n\n.Message-Red {\n  color: red;\n  font-weight: 400;\n}\n\n.Message-Blue {\n  color: blue;\n  font-weight: 400;\n}\n\n.Right-Align {\n  align-items: right;\n  text-align: right;\n}\n\n.withdraw-panel {\n  padding: 8px;\n  background: #fff;\n  border-radius: 4px;\n  min-height: 100%;\n  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);\n}\n\n.adminTable {\n  border: 1px solid black;\n  border-collapse: collapse;\n  margin-bottom: 12px;\n  line-height: 1.68;\n}\n\n.adminTR {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n\n.adminTH {\n  border: 1px solid black;\n  border-collapse: collapse;\n  text-align: center;\n  font-weight: 600;\n  font-size: 12px;\n  color: #fff;\n  background-color: #bebdbd;\n}\n\n.adminTD {\n  border: 1px solid black;\n  border-collapse: collapse;\n  word-break: break-all;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.adminTDError {\n  border: 1px solid black;\n  border-collapse: collapse;\n  word-break: break-all;\n  font-weight: 500;\n  font-size: 12px;\n  color: #ff0000;\n}\n\n.imgThumbnail {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 5px;\n  width: 150px;\n}\n\n/* Pagination styling */\n.pagination {\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  list-style: none;\n  margin-top: 20px;\n}\n\n.pagination li {\n  margin: 0 5px;\n}\n\n.pagination li a {\n  display: inline-block;\n  padding: 10px 15px;\n  background-color: white;\n  color: #007bff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  text-decoration: none;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.pagination li a:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n.pagination li.active a {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
